<template>

  <div class="documents-section">

    <div class="accordion-section">

      <div style="font-size: 18px; font-weight: 600">

        <span>

          Fecha de generación de Solicitud:

          {{ app.application.createdAt.split(" ")[0] }}

        </span>

      </div>

      <!--TITULAR-->

      <Accordion title="Titular" id="titular" :key="'titular'" :eventHub="eventHub">

        <div v-if="titularOpen" class="accordion-content">

          <AccordionAdmin title="De solicitud" id="titularSol" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="checkToCorrect" class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <!-- <div v-if="loginUserType == 'PARTNER_SERVICE' && (app.application.applicationStatus == 'IN_REVIEW_BY_PARTNER_SERVICE' || app.application.applicationStatus == 'DOCUMENTATION_FINISHED' )" class="t1-checkbox" style="float: right"> -->

                    <div class="t1-checkbox">

                      <input v-if="checkToCorrect" type="checkbox" id="titularSolCheck"

                        v-model="secciones[0].titularSol.check" />

                      <label v-if="checkToCorrect" for="titularSolCheck" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[0].titularSol.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_BY_PARTNER_SERVICE'

                      " trigger="click" :options="{ placement: 'right' }" class="popOverClass">

                        <span slot="header">Comentarios</span>

                        <div slot="body" class="form__group">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[0].titularSol"

                            style="font-size: 15px" :disabled="!secciones[0].titularSol.check"></textarea>

                          <Btn v-if="

                            !secciones[0].titularSol.save &&

                            secciones[0].titularSol.check

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Solicitud', 'Titular', {})

"></Btn>

                        </div>

                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="4">

                      <div v-for="item in app.documents" :key="item.id">

                        <img v-if="item.documentType == 'PROFILE_PICTURE'" class="avatar-pic" :src="item.publicURL"

                          alt="Profile Picture" @click="openModal2(item.publicURL, 'Foto titular')" />

                        <div v-if="item.documentType == 'PROFILE_PICTURE'" class="zoom-pic"

                          @click="openModal2(item.publicURL, 'Foto titular')"></div>

                      </div>

                    </mdb-col>

                    <mdb-col v-if="app.application.applicationNumber" md="4">

                      <label for="input_appN" class="form__label">No. de solicitud:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.application.applicationNumber"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.payment" md="4">

                      <label for="input_pay_date" class="form__label">Fecha de pago:</label>

                      <input type="text" id="input_pay_Date" class="form__input" v-model="app.application.payment.date"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.name" md="4">

                      <label for="input_name" class="form__label">Nombre:</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.name" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.lastName" md="4">

                      <label for="input_lastname" class="form__label">Apellido parterno:</label>

                      <input type="text" id="input_lastname" class="form__input" v-model="app.lastName" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.mothersLastName" md="4">

                      <label for="input_Mlastname" class="form__label">Apellido materno:</label>

                      <input type="text" id="input_Mlastname" class="form__input" v-model="app.mothersLastName"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.application.applicantType.applicationTypeValue" md="4">

                      <label for="input_name" class="form__label">Tipo de usuario:</label>

                      <input type="text" id="input_name" class="form__input" v-model="

                        app.application.applicantType.applicantTypeValue

                      " disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.proceedingType" md="4">

                      <label for="input_lastname" class="form__label">Tipo de trámite:</label>

                      <input type="text" id="input_lastname" class="form__input" v-model="

                        app.application.proceedingType.proceedingTypeValue

                      " disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.subProceedingType" md="4">

                      <label for="input_subProceeding" class="form__label">Tipo de venta:</label>

                      <input type="text" id="input_subProceeding" class="form__input" v-model="

                        app.application.subProceedingType

                          .subProceedingTypeValue

                      " disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.membership" md="4">

                      <label for="input_Mlastname" class="form__label">Tipo de acción:</label>

                      <input type="text" id="input_Mlastname" class="form__input"

                        v-model="app.application.membership.membershipName" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row v-show="

                    app.application.applicantType.applicantTypeValue ==

                    'Propietario'

                  " class="mt-3">

                    <mdb-col v-show="false" md="4">

                      <label for="input_name" class="form__label">Titular de la propiedad:</label>

                      <input type="text" id="input_name" class="form__input" disabled />

                    </mdb-col>

                    <mdb-col md="4"></mdb-col>

                    <mdb-col md="4"></mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.application.seller" md="8">

                      <label for="input_name" class="form__label">Nombre del asesor de ventas:</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.application.seller"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.payment" md="4">

                      <label for="input_lastname" class="form__label">Total pagado:</label>

                      <input type="text" id="input_lastname" class="form__input"

                        :value="toMoney(app.application.payment.total)" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row v-if="app.application.owner" class="mt-3">

                    <mdb-col md="8">

                      <label for="input_name" class="form__label">Nombre de a quién quedará la propiedad:</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.application.owner" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.application.previousOwner" md="8">

                      <label for="input_name" class="form__label">{{

                          labelPropietario

                      }}</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.application.previousOwner"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.addressGround" md="8">

                      <label for="input_name" class="form__label">{{

                          labelDomicilio

                      }}</label>

                      <textarea class="form__input" rows="5" id="input_name" v-model="app.application.addressGround"

                        disabled></textarea>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.application.numberAction" md="4">

                      <label for="input_name" class="form__label">{{

                          labelAccion

                      }}</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.application.numberAction"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="app.application.numberGround" md="4">

                      <label for="input_name" class="form__label">{{

                          labelTerreno

                      }}</label>

                      <input type="text" id="input_name" class="form__input" v-model="app.application.numberGround"

                        disabled />

                    </mdb-col>

                  </mdb-row>



                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <Btn v-if="DeedOrAgreement" :text="'Escrituras'" icon="revisar" :type="'primary-admin'" @onClick="

                        openModal(DeedOrAgreement.publicURL, 'Escrituras')

                      "></Btn>

                    </mdb-col>

                    <mdb-col md="6">

                      <Btn v-if="PropertyPayment" :text="'Pago de predial'" icon="revisar" :type="'primary-admin'"

                        @onClick="

                          openModal(PropertyPayment.publicURL, 'Pago predial')

                        "></Btn>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>

          <!-- PERSONALES-->

          <AccordionAdmin title="Personales" id="titularPerso" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="checkToCorrect" class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="checkToCorrect" type="checkbox" id="titularPerso"

                        v-model="secciones[0].titularPerso.check" />

                      <label v-if="checkToCorrect" for="titularPerso" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[0].titularPerso.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_BY_PARTNER_SERVICE'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[0].titularPerso"

                            style="font-size: 15px" :disabled="!secciones[0].titularPerso.check"></textarea>

                          <Btn v-if="

                            !secciones[0].titularPerso.save &&

                            secciones[0].titularPerso.check

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Personales', 'Titular', {})

"></Btn>

                        </div>

                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col v-if="app.birthDate" md="6">

                      <label for="input_appN" class="form__label">Fecha de nacimiento:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.birthDate" disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">Edad:</label>

                      <input type="text" id="input_appN" class="form__input" :value="edad" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="6">

                      <label for="input_name" class="form__label">Estado civil:</label>

                      <input type="text" id="input_name" class="form__input" :value="marital" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.exSpouseFullName" md="6">

                      <label for="input_lastname" class="form__label">Nombre ex espos@:</label>

                      <input type="text" id="input_lastname" class="form__input" v-model="app.exSpouseFullName"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <!-- <mdb-col md="6">

                      <div v-for="item in app.documents" :key="item.id">

                        <label

                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                          for="input_name"

                          class="form__label"

                        >INE/PASAPORTE:</label>

                        <input

                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                          type="text"

                          id="input_name"

                          :value="item.value"

                          class="form__input"

                          disabled

                        />

                      </div>

                    </mdb-col>-->

                    <mdb-col md="6">

                      <div v-for="item in app.documents" :key="item.id">

                        <label v-if="item.documentType == 'CURP'" for="input_name" class="form__label">CURP:</label>

                        <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"

                          class="form__input" disabled />

                      </div>

                    </mdb-col>

                    <mdb-col md="4"></mdb-col>

                  </mdb-row>



                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <div v-for="item in app.documents" :key="item.id">

                        <Btn v-if="

                          item.documentType == 'INE' ||

                          item.documentType == 'PASSPORT'

                        " :text="'IDENTIFICACIÓN OFICIAL'" icon="revisar" :type="'primary-admin'" @onClick="

  openModal(item.publicURL, 'Identificación Oficial')

"></Btn>

                      </div>

                    </mdb-col>

                    <mdb-col md="3">

                      <div v-for="item in app.documents" :key="item.id">

                        <Btn v-if="item.documentType == 'CURP'" :text="'CURP'" icon="revisar" :type="'primary-admin'"

                          @onClick="openModal(item.publicURL, 'CURP')"></Btn>

                      </div>

                    </mdb-col>

                    <mdb-col md="5">

                      <div v-for="item in app.documents" :key="item.id">

                        <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE'" :text="'ACTA DE NACIMIENTO'" icon="revisar"

                          :type="'primary-admin'" @onClick="

                            openModal(item.publicURL, 'Acta de nacimiento')

                          "></Btn>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <!--DE CONTACTO-->

          <AccordionAdmin v-if="app.user.username" title="De contacto" id="titularCon" style="padding: 0">

            <div class="accordion-content">

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="8">

                      <label for="input_appN" class="form__label">Correo electrónico:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.user.username" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <div v-for="(item, index) in app.phones" :key="index">

                      <mdb-col md="12">

                        <label for="input_appN" class="form__label">Télefono {{ item.phoneType }}:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <!--DE DOMICILIO-->

          <AccordionAdmin v-if="app.address != null" title="Domicilio" id="titularDom" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="

                      loginUserType == 'PARTNER_SERVICE' &&

                      app.application.applicationStatus ==

                      'DOCUMENTATION_FINISHED'

                    " class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " type="checkbox" id="titularDom" v-model="secciones[0].titularDom.check" />

                      <label v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " for="titularDom" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[0].titularDom.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_ACCEPTED'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[0].titularDom"

                            style="font-size: 15px" :disabled="

                              app.application.applicationStatus ==

                              'IN_EDIT_ACCEPTED'

                            "></textarea>

                          <Btn v-if="

                            !secciones[0].titularDom.save &&

                            app.application.applicationStatus !=

                            'IN_EDIT_ACCEPTED'

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Domicilio', 'Titular', {})

"></Btn>

                        </div>



                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Estado:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressT.state" disabled />

                    </mdb-col>



                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Ciudad:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressT.city" disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">C. P.:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressT.zipCode" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Colonia:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressT.colony" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.address" md="4">

                      <label for="input_appN" class="form__label">Calle:</label>

                      <input type="text" id="input_appN" class="form__input" :value="app.address.street" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.address.externalNumber" md="2">

                      <label for="input_appN" class="form__label">No. Ext.:</label>

                      <input type="text" id="input_appN" class="form__input" :value="app.address.externalNumber"

                        disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">No. Int.:</label>

                      <input type="text" id="input_appN" class="form__input" :value="app.address.interiorNumber"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="8">

                      <div v-for="item in app.documents" :key="item.id">

                        <Btn v-if="item.documentType == 'PROOF_OF_ADDRESS'" :text="'Comprobante de domicilio'"

                          icon="revisar" :type="'primary-admin'" @onClick="

                            openModal(

                              item.publicURL,

                              'Comprobante de domicilio'

                            )

                          "></Btn>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <!--CONTACTO DE EMERGENCIA REVISAR COMO PINTAR ESTE DE AQUI!!!!!!!!!-->

          <div v-for="(item, index) in app.phones" :key="index">

            <AccordionAdmin v-if="item.phoneType == 'Emergency'" title="Contacto de emergencia" id="titularEme"

              style="padding: 0">

              <div class="accordion-content">

                <mdb-row>

                  <mdb-col md="12">

                    <mdb-row>

                      <mdb-col md="12">

                        <label for="input_appN" class="form__label">Nombre del contacto:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.contactName" disabled />

                      </mdb-col>



                      <!-- <mdb-col md="4">

                    <label for="input_appN" class="form__label">Apellido paterno:</label>

                    <input type="text" id="input_appN" class="form__input" :value="titularEmergencia.contactName" disabled />

                  </mdb-col>

                  <mdb-col md="4">

                    <label for="input_appN" class="form__label">Apellido materno:</label>

                    <input type="text" id="input_appN" class="form__input" :value="titularEmergencia.contactName" disabled />

                      </mdb-col>-->

                    </mdb-row>

                    <mdb-row class="mt-3">

                      <mdb-col md="4">

                        <label for="input_appN" class="form__label">Parentesco:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"

                          disabled />

                      </mdb-col>

                      <mdb-col md="4">

                        <label for="input_appN" class="form__label">Télefono celular:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                    </mdb-row>

                  </mdb-col>

                </mdb-row>

              </div>

            </AccordionAdmin>

          </div>



          <!-- LABORALES-->

          <AccordionAdmin title="Datos laborales" id="titularLab" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="checkToCorrect" class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="checkToCorrect" type="checkbox" id="titularLab"

                        v-model="secciones[0].titularLab.check" />

                      <label v-if="checkToCorrect" for="titularLab" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[0].titularLab.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_BY_PARTNER_SERVICE'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[0].titularLab"

                            style="font-size: 15px" :disabled="!secciones[0].titularLab.check"></textarea>

                          <Btn v-if="

                            !secciones[0].titularLab.save &&

                            secciones[0].titularLab.check

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Laborales', 'Titular', {})

"></Btn>

                        </div>



                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <label class="form__label">Labora actualmente: </label>

                  <div class="form__check">

                    <span v-if="app.laborData.working" style="font-weight: 700; font-size: 15px">

                      Si

                    </span>

                    <span v-else style="font-weight: 700; font-size: 15px">

                      No

                    </span>

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12" v-if="app.laborData.working">

                  <!-- Nombre de la empresa-->

                  <mdb-row>

                    <mdb-col v-if="app.laborData.company" md="12">

                      <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.laborData.company" disabled />

                    </mdb-col>

                  </mdb-row>

                  <!-- Giro d ela empresa -->

                  <mdb-row>

                    <mdb-col md="12">

                      <label for="input_appN" class="form__label">Giro de la empresa:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.laborData.businessActivity"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <!-- Domicilio de la empresa-->

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.laborData.addressCompany" md="12">

                      <label for="input_appN" class="form__label">Domicilio de la empresa:</label>

                      <!-- <input

                        type="text"

                        id="input_appN"

                        class="form__input"

                        v-model="app.laborData.addressCompany"

                        disabled

                      /> -->

                      <textarea id="input_appN" rows="5" class="form__input" v-model="app.laborData.addressCompany"

                        disabled></textarea>

                    </mdb-col>

                  </mdb-row>

                  <!-- Telefono y profesion -->

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.laborData.phone" md="4">

                      <label for="input_appN" class="form__label">Teléfono de la empresa:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.laborData.phone" disabled />

                    </mdb-col>



                    <mdb-col v-if="app.laborData.phone" md="8">

                      <label for="input_appN" class="form__label">Profesión:

                      </label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.laborData.profession"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <!-- Puesto -->

                  <mdb-row class="mt-3">

                    <mdb-col md="12">

                      <label for="input_appN" class="form__label">Puesto que desempeña:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="app.laborData.position"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

                <mdb-col md="12" v-else>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="app.laborData.activityDescription" md="8">

                      <label for="input_appN" class="form__label">A qué se dedica:

                      </label>



                      <textarea id="input_appN" rows="5" class="form__input" v-model="app.laborData.activityDescription"

                        readonly></textarea>

                    </mdb-col>



                    <mdb-col v-if="app.laborData.phone" md="4"> </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row v-if="TaxStatusLetter" class="mt-3">

                <mdb-col md="6">

                  <Btn :text="'CONSTANCIA DE SITUACIÓN FISCAL'" icon="revisar" :type="'primary-admin'" @onClick="

                    openModal(

                      TaxStatusLetter.publicURL,

                      'Constancia de situación fiscal'

                    )

                  "></Btn>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <!-- DE FACTURACIÓN-->

          <AccordionAdmin v-if="app.billingInformation != null" title="Datos de facturación" id="titularFact"

            style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="

                      loginUserType == 'PARTNER_SERVICE' &&

                      app.application.applicationStatus ==

                      'DOCUMENTATION_FINISHED'

                    " class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " type="checkbox" id="titularFact" v-model="secciones[0].titularFact.check" />

                      <label v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " for="titularFact" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[0].titularFact.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_ACCEPTED'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[0].titularFact"

                            style="font-size: 15px"></textarea>



                          <Btn v-if="!secciones[0].titularFact.save" :text="'Guardar'" :type="'primary-admin'" @onClick="

                            saveDataUpdate('Facturacion', 'Titular', {})

                          "></Btn>

                        </div>

                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="8">

                      <label for="input_appN" class="form__label">Nombre o razón social:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="app.billingInformation.businessSocialReason" disabled />

                    </mdb-col>

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">RFC:</label>

                      <input type="text" id="input_appN" class="form__input" :value="app.billingInformation.rfc"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="10">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">

                          |

                          <b>DOMICILIO DE FACTURACIÓN</b>

                        </label>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Estado:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="addressBill.state" disabled />

                    </mdb-col>



                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Ciudad:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressBill.city" disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">C. P.:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressBill.zipCode" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Colonia:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressBill.colony" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.billingInformation" md="4">

                      <label for="input_appN" class="form__label">Calle:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="app.billingInformation.address.street" disabled />

                    </mdb-col>

                    <mdb-col v-if="app.billingInformation.address.externalNumber" md="2">

                      <label for="input_appN" class="form__label">No. Ext.:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="app.billingInformation.address.externalNumber" disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">No. Int.:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="app.billingInformation.address.interiorNumber" disabled />

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <mdb-row class="accordion-content" style="padding: 2rem">

            <mdb-col col="12">

              <mdb-row>

                <nav>

                  <ul class="t1-navigation">

                    <li @click="indexPop = 1" :class="indexPop == 1 ? 't1-navigation--active' : ''"

                      style="height: 4.5rem">

                      <a @click="indexPop = 1">Autos</a>

                    </li>

                    <li @click="indexPop = 2" :class="indexPop == 2 ? 't1-navigation--active' : ''"

                      style="height: 4.5rem">

                      <a>Recomendaciones de socios</a>

                    </li>

                    <li @click="indexPop = 3" :class="indexPop == 3 ? 't1-navigation--active' : ''"

                      style="height: 4.5rem">

                      <a>Investigación JusWho</a>

                    </li>

                    <li v-show="hasPermissionToDownloadDocuments" :class="indexPop === 4 ? 't1-navigation--active' : ''"

                      style="height: 4.5rem" @click="indexPop = 4">

                      <a>Descargar documentos</a>

                    </li>

                    <li @click="indexPop = 5" :class="indexPop == 5 ? 't1-navigation--active' : ''"

                      style="height: 4.5rem">

                      <a>Comentarios correción</a>

                    </li>

                    <!-- <li :class="indexPop == 6 ? 't1-navigation--active' : ''">

                      <a @click="indexPop = 6">Cometarios correción</a>

                    </li> -->

                    <!-- <li :class="indexPop ==3 ? 't1-navigation--active':''">

                        <a @click="indexPop=3">Titulos de propiedad</a>

                    </li>-->

                  </ul>

                </nav>

              </mdb-row>

              <mdb-row v-if="indexPop == 1 && app.cars.length > 0">

                <table class="table table-striped" style="border: solid 1px #bdbdbd">

                  <tr class="tableHeader" style="font-size: 14px">

                    <th>Marca</th>

                    <th>Modelo</th>

                    <th>Año</th>

                    <th>Color</th>

                    <th>Factura</th>

                    <th>Datos incorrectos</th>

                  </tr>

                  <tbody>

                    <tr v-for="(item, index) in app.cars" v-bind:key="index" style="font-size: 1.4rem">

                      <td>{{ item.brand }}</td>

                      <td>{{ item.model }}</td>

                      <td>{{ item.year }}</td>

                      <td>{{ item.color }}</td>

                      <td>

                        <button type="button" class="btn btn-edit" style="padding: 3px" @click="

                          getFactura(

                            item.plates,

                            'Factura de carro: ' + item.plates

                          )

                        ">

                          <img :src="'/img/icons/InoVerPDF.svg'" alt="icon ver" />

                        </button>

                      </td>

                      <td>

                        <div class="t1-checkbox" style="float: center">

                          <input v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " type="checkbox" :id="'car' + index" v-model="

                            secciones[0].titularCars['car' + index].check

                          " />

                          <label v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " :for="'car' + index" class="form__label">

                            <span class="check-custom2" style="background-color: white !important"></span>

                          </label>

                          <mdb-popover v-if="

                            secciones[0].titularCars['car' + index].check ||

                            app.application.applicationStatus ==

                            'IN_EDIT_ACCEPTED'

                          " trigger="click" :options="{ placement: 'right' }">

                            <span slot="header">Comentarios</span>

                            <div class="form__group" slot="body">

                              <textarea class="form-control" rows="15" maxlength="300" style="font-size: 15px" v-model="

                                comentarios[0].titularCars['car' + index]

                              " :disabled="

                                app.application.applicationStatus ==

                                'IN_EDIT_ACCEPTED'

                              "></textarea>



                              <Btn v-if="

                                !secciones[0].titularCars['car' + index]

                                  .save &&

                                app.application.applicationStatus !=

                                'IN_EDIT_ACCEPTED'

                              " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Autos', 'Titular', {

    id: item.id,

    comment:

      comentarios[0].titularCars['car' + index],

    index: index,

  })

"></Btn>

                            </div>

                            <button type="button" class="btn btn-edit" style="

                                position: absolute;

                                padding: 0px;

                                margin-top: -1rem;

                              " slot="reference">

                              <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                            </button>

                          </mdb-popover>

                        </div>

                      </td>

                    </tr>

                  </tbody>

                </table>

              </mdb-row>

              <mdb-row v-else-if="indexPop == 2">

                <table class="table" style="border: solid 1px #bdbdbd">

                  <tr class="tableHeader">

                    <th v-if="loginUserType != 'CLUB_ADMIN'">Confirmado</th>

                    <th>Nombre de socio titular que recomienda</th>

                    <th>No. de acción</th>

                    <th>Correo electrónico</th>

                    <th>Teléfono celular</th>

                    <th v-if="loginUserType != 'CLUB_ADMIN'">

                      Comentarios para el comite

                    </th>

                    <th v-if="

                      loginUserType != 'CLUB_ADMIN' &&

                      loginUserType != 'COMMITTEE'

                    ">

                      Corregir

                    </th>

                  </tr>

                  <tbody>

                    <tr style="font-size: 1.4rem" v-for="(item, index) in app.recommendations" v-bind:key="index">

                      <td v-if="loginUserType != 'CLUB_ADMIN'">

                        <mdb-row>

                          <mdb-col sm="4">

                            <mdb-row class="mb-2" style="width: 10rem">

                              <mdb-col sm="2">

                                <div class="t1-checkbox">

                                  <label v-if="check[index]" :for="index">

                                    <input type="radio" :id="index" :value="true" v-model="check[index]"

                                      :disabled="loginUserType == 'COMMITTEE'" />

                                    <img :src="'/img/icons/Box_Approved.svg'" />

                                  </label>

                                  <label v-else :for="index">

                                    <input type="radio" :id="index" :value="true" v-model="check[index]"

                                      :disabled="loginUserType == 'COMMITTEE'" />

                                    <img :src="'/img/icons/Box_NotA.svg'" />

                                  </label>

                                </div>

                              </mdb-col>

                              <mdb-col sm="2">

                                <div class="t1-checkbox">

                                  <label v-if="!check[index]" :for="index + '2'">

                                    <input type="radio" :id="index + '2'" :value="false" v-model="check[index]"

                                      :disabled="loginUserType == 'COMMITTEE'" />

                                    <img :src="'/img/icons/Box_NotApproved.svg'" />

                                  </label>

                                  <label v-else :for="index + '2'">

                                    <input type="radio" :id="index + '2'" :value="false" v-model="check[index]"

                                      :disabled="loginUserType == 'COMMITTEE'" />

                                    <img :src="'/img/icons/Box_A.svg'" />

                                  </label>

                                </div>

                              </mdb-col>

                            </mdb-row>

                          </mdb-col>

                        </mdb-row>

                      </td>

                      <td>

                        {{

                            item.partnerName +

                            " " +

                            item.partnerLastName +

                            " " +

                            item.partnerMothersLastName

                        }}

                      </td>

                      <td>{{ item.deedNumber }}</td>

                      <td>{{ item.email }}</td>

                      <td>{{ item.cellPhone }}</td>

                      <td v-if="loginUserType != 'CLUB_ADMIN'">

                        <button type="button" class="btn btn-edit" style="padding: 0px"

                          @click="checkRecomendation(index)">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </td>

                      <td v-if="

                        loginUserType != 'CLUB_ADMIN' &&

                        loginUserType != 'COMMITTEE'

                      ">

                        <div class="t1-checkbox" style="float: right">

                          <input v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'IN_REVIEW_BY_PARTNER_SERVICE'

                          " type="checkbox" :id="item.id"

                            v-model="secciones[0].titularRecomendations['socio' + index].check" />

                          <label v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'IN_REVIEW_BY_PARTNER_SERVICE'

                          " :for="item.id" class="form__label">

                            <span class="check-custom2" style="background-color: white !important"></span>

                          </label>

                          <mdb-popover v-if="

                            secciones[0].titularRecomendations[

                              'socio' + index

                            ].check ||

                            app.application.applicationStatus ==

                            'IN_EDIT_BY_PARTNER_SERVICE'

                          " trigger="click" :options="{ placement: 'right' }">

                            <span slot="header">Comentarios aqui</span>

                            <div class="form_group" slot="body">

                              <textarea class="form-control" rows="15" maxlength="300" v-model="

                                comentarios[0].titularRecomendations[

                                'socio' + index

                                ]

                              " style="font-size: 15px"

                                :disabled="app.application.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE' && loginUserType!='PARTNER_SERVICE'"></textarea>

                              <Btn 

                                v-if="

                                  !secciones[0].titularRecomendations['socio' + index].save 

                                  &&

                                  (app.application.applicationStatus !='IN_EDIT_BY_PARTNER_SERVICE' || loginUserType=='PARTNER_SERVICE' )" 

                                

                                :text="'Guardar'" 

                                :type="'primary-admin'" 

                                @onClick="saveDataUpdate('Recomendaciones', 'Titular', {

                                  id: item.id,

                                  comment:comentarios[0].titularRecomendations['socio' + index],

                                  index: index,})"></Btn>

                            </div>

                            <button type="button" class="btn btn-edit" style="padding: 0px" slot="reference">

                              <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                            </button>

                          </mdb-popover>

                        </div>

                      </td>

                    </tr>

                  </tbody>

                </table>

              </mdb-row>

              <mdb-row v-show="indexPop == 2 && showTextArea">

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="12">

                      <label class="labelClass" :id="'recomendation' + indexRecomendation">Recomendación {{

                          indexRecomendation

                      }}</label>

                      <textarea class="form-control" :id="'recomendation' + indexRecomendation" rows="10"

                        maxlength="1500" style="font-size: 15px" v-model="textComment" :disabled="

                          loginUserType == 'COMMITTEE' ||

                          (app.application.applicationStatus !=

                            'IN_REVIEW_BY_PARTNER_SERVICE' &&

                            app.application.applicationStatus !=

                            'IN_EDIT_BY_PARTNER_SERVICE')

                        "></textarea>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="12">

                      <Btn v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        (app.application.applicationStatus ==

                          'IN_REVIEW_BY_PARTNER_SERVICE' ||

                          app.application.applicationStatus ==

                          'IN_EDIT_BY_PARTNER_SERVICE')

                      " style="float: right" :text="'Agregar comentario'" @onClick="saveRecomendations"

                        :type="'primary-admin'"></Btn>

                      <Btn v-else style="float: right" :text="'Agregar comentario'" :type="'disabled-admin'"></Btn>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row v-show="

                indexPop == 3 &&

                app.application.applicationStatus != 'CREATED'

              ">

                <div v-if="app.investigations.length > 0" style="width: 100%; background: white">

                  <mdb-row>

                    <mdb-col md="6"></mdb-col>

                    <mdb-col md="6">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important; color: #dc7134">Fecha de

                          Investigación:

                          {{ app.investigations[0].createdAt }}</label>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="6"></mdb-col>

                    <mdb-col md="6">

                      <div class="form__group mt-2">

                        <div v-if="

                          fileExtra == null &&

                          (app.application.applicationStatus ==

                            'IN_REVIEW_BY_PARTNER_SERVICE' ||

                            app.application.applicationStatus ==

                            'IN_EDIT_BY_PARTNER_SERVICE')

                        " class="form__group">

                          <label for="curp-input" class="btn-label">

                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />

                            SUBIR INVESTIGACIÓN EXTRA

                          </label>

                          <input type="file" accept="application/pdf" name="file" id="curp-input"

                            style="visibility: hidden" @change="uploadExtra" />

                        </div>



                        <div v-if="fileExtra != null" class="input-group">

                          <btn v-if="fileExtraBase64 != null" :text="'¡GUARDAR INVESTIGACIÓN EXTRA!'"

                            @onClick="saveExtraInvestigation" :type="'primary-admin'" style="float: left"></btn>

                          <btn v-else :text="'¡INVESTIGACIÓN EXTRA GUARDADA!'" :type="'primary-admin-success'"

                            style="float: left"></btn>

                          <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"

                            @click="openModal(fileExtra, 'Investigación Extra')" />

                        </div>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Personales</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Fecha de nacimiento:</label>

                            <input type="text" id="input_name" class="form__input"

                              v-model="app.investigations[0].birthDate" disabled />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Denominación:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].denomination" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Identificación:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].identification" />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Identificación Tributaria:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].taxIdentification" />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Otra Identificación:</label>

                            <input v-if="

                              app.investigations[0].otherIdentification != ''

                            " type="text" id="input_name" class="form__input" disabled v-model="

  app.investigations[0].otherIdentification

" />

                            <input v-else type="text" id="input_name" class="form__input" disabled

                              :value="'NO DISPONIBLE'" />

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Laborales</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Cargo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].position" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Lugar de trabajo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].workplace" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Dirección de trabajo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].address" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Enlace a página web:</label>

                            <a style="font-size: 18px" :href="app.investigations[0].link">Sitio web</a>

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Tipo de persona</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Tipo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].type" />

                          </mdb-col>

                          <mdb-col v-if="app.investigations[0].type == 'TER'" md="4">

                            <label for="input_name" class="form__label">SubTipo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].subType" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Estado:</label>

                            <input type="text" id="input_name" class="form__input" v-model="app.investigations[0].state"

                              disabled />

                          </mdb-col>

                          <mdb-col v-if="app.investigations[0].state == 'INACTIVO'" md="4">

                            <label for="input_name" class="form__label">Finalización del cargo:</label>

                            <input type="text" id="input_name" class="form__input"

                              :value="app.investigations[0].terminationOfOffice" disabled />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Lista:</label>

                            <input type="text" id="input_name" class="form__input" v-model="app.investigations[0].list"

                              disabled />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">País de la lista:</label>

                            <input v-if="app.investigations[0].countryList != ''" type="text" id="input_name"

                              class="form__input" disabled v-model="app.investigations[0].countryList" />

                            <input v-else type="text" id="input_name" class="form__input" disabled

                              :value="'NO DISPONIBLE'" />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Código del individuo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="app.investigations[0].individualCode" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Exactitud denominación:</label>

                            <input v-if="app.investigations[0].namingAccuracy != ''" type="text" id="input_name"

                              class="form__input" v-model="app.investigations[0].namingAccuracy" disabled />

                            <input v-else type="text" id="input_name" class="form__input" :value="'NO DISPONIBLE'"

                              disabled />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Exactitud indentificación:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              app.investigations[0].identificationAccuracy

                            " />

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </div>

                <div v-else class="divClass">

                  <mdb-row>

                    <mdb-col cols="12">

                      <div class="form__group mt-2">

                        <div v-if="

                          fileExtra == null &&

                          app.application.applicationStatus ==

                          'IN_REVIEW_BY_PARTNER_SERVICE'

                        " class="form__group">

                          <label for="curp-input" class="btn-label">

                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />

                            SUBIR INVESTIGACIÓN EXTRA

                          </label>

                          <input type="file" accept="application/pdf" name="file" id="curp-input"

                            style="visibility: hidden" @change="uploadExtra" />

                        </div>



                        <div v-if="fileExtra != null" class="input-group">

                          <btn v-if="fileExtraBase64 != null" :text="'¡GUARDAR INVESTIGACIÓN EXTRA!'"

                            @onClick="saveExtraInvestigation" :type="'primary-admin'" style="float: left"></btn>

                          <btn v-else :text="'¡INVESTIGACIÓN EXTRA GUARDADA!'" :type="'primary-admin-success'"

                            style="float: left"></btn>

                          <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"

                            @click="openModal(fileExtra, 'Investigación Extra')" />

                        </div>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <!--<mdb-row v-if="

                    app.investigationResultMessage !=

                    'Sin envío a investigación de PDL'

                  ">

                    <p class="mt-5" style="font-size: 18px; font-weight: 600; color: #828282">

                      <img src="/img/icons/approved-default.svg" alt="Aproved" />

                      SOLICITANTE CON HISTORIAL LIMPIO

                    </p>



                    <p style="text-align: justify">

                      <b>El resultado de investigación para este Solicitante ha

                        sido realizado y no se han encontrado datos como persona

                        PEP (Persona Expuesta Políticamente) o TER

                        (Terrorista)</b>, así como delictivos que deban tomarse en cuenta para su

                      proceso de admisión.

                    </p>

                  </mdb-row>-->

                </div>

              </mdb-row>

              <mdb-row v-show="indexPop === 4 && hasPermissionToDownloadDocuments" class="m-1 w-100">

                <mdb-col col="12">

                  <div class="bg-white p-4" style="border: 1px solid #3a8a65; border-radius: 5px">

                    <h3 class="h3 font-weight-bold mb-4">Titular</h3>



                    <div v-for="item in filterDocumentsForCheck(

                      app.documents,

                      'documentType'

                    )" :key="item.id" class="form__group">

                      <div class="t1-checkbox ml-5">

                        <input v-model="selectedDocuments.titular[item.documentType]" type="checkbox"

                          :id="`TITULAR_${item.documentType}`" />

                        <label :for="`TITULAR_${item.documentType}`" class="form__label">

                          <span class="check-custom"></span>

                          {{ LIST_DOCUMENTS_TRANSLATE[item.documentType] }}

                        </label>

                      </div>

                    </div>



                    <div class="mt-5 d-flex flex-row align-items-center">

                      <Btn @onClick="

                        downloadFiles({

                          applicantId: app.id,

                          type: 'titular',

                        })

                      " class="mr-3" :text="'DESCARGAR SELECCIONADOS'" icon="download" :type="'primary-admin'"></Btn>

                      <Btn @onClick="

                        downloadFiles(

                          { applicantId: app.id },

                          getTypesFromDocuments(app.documents)

                        )

                      " :text="'DESCARGAR TODOS'" icon="download" :type="'primary-admin'"></Btn>

                    </div>

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row v-show="indexPop == 5" style="display: contents">

                <div v-if="corrections.length > 0" style="

                    font-size: 15px;

                    text-transform: uppercase;

                    padding: 15px;

                    max-height: 500px;

                    overflow-y: auto;

                  ">

                  <div v-for="(item, index) in corrections" :key="index">

                    <p class="d-flex justify-content-start" style="font-size: 15px; font-weight: 600; color: #dc7134">

                      Fecha de envio a correción:

                      {{

                          item.editFrom ? item.editFrom : "Sin Fecha Registrada"

                      }}

                    </p>

                    <p class="d-flex justify-content-start" style="font-size: 15px; font-weight: 600; color: #dc7134">

                      Fecha en que el titular realizó la correción:

                      {{ item.editAt ? item.editAt : "Sin Fecha Registrada" }}

                    </p>

                    <p style="font-size: 15px; font-weight: 600; color: #000">

                      Titular

                    </p>

                    <ul>

                      <li v-if="

                        findDocumentwithComment(

                          item.corrections.documents,

                          'PROFILE_PICTURE'

                        )

                      ">

                        Solicitud:

                        {{

                            findDocumentwithComment(

                              item.corrections.documents,

                              "PROFILE_PICTURE"

                            ).comment

                        }}

                      </li>

                      <li v-if="

                        findDocumentwithComment(

                          item.corrections.documents,

                          'CURP'

                        )

                      ">

                        Personales:

                        {{

                            findDocumentwithComment(

                              item.corrections.documents,

                              "CURP"

                            ).comment

                        }}

                      </li>

                      <li v-if="

                        findDocumentwithComment(

                          item.corrections.documents,

                          'PROOF_OF_ADDRESS'

                        )

                      ">

                        Domicilio:

                        {{

                            findDocumentwithComment(

                              item.corrections.documents,

                              "PROOF_OF_ADDRESS"

                            ).comment

                        }}

                      </li>

                      <li v-if="item.corrections.laborData.comment">

                        Laborales: {{ item.corrections.laborData.comment }}

                      </li>

                      <li v-for="car in item.corrections.cars" :key="index + '-' + car">

                        Autos: {{ car.comment }}

                      </li>

                      <li v-if="item.corrections.billingInformation.comment">

                        Facturacion:

                        {{ item.corrections.billingInformation.comment }}

                      </li>

                    </ul>

                    <p v-if="item.corrections.recommendations.length > 0"

                      style="font-size: 15px; font-weight: 600; color: #000">

                      Recomendaciones

                    </p>

                    <ol>

                      <li v-for="(item2, index2) in item.corrections

                      .recommendations" :key="index2">

                        {{ item2.commentApplicant }}

                      </li>

                    </ol>

                    <div v-for="itemBenef in item.corrections.beneficiaries" :key="itemBenef.beneficiaryType">

                      <p v-if="itemBenef.beneficiaryType == 'SPOUSE'"

                        style="font-size: 15px; font-weight: 600; color: #000">

                        Cónyuge -

                        {{

                            itemBenef.name +

                            " " +

                            itemBenef.lastName +

                            " " +

                            itemBenef.mothersLastName

                        }}

                      </p>

                      <p v-else-if="itemBenef.beneficiaryType == 'OLDER_CHILD'"

                        style="font-size: 15px; font-weight: 600; color: #000">

                        HIJ@ MAYOR -

                        {{

                            itemBenef.name +

                            " " +

                            itemBenef.lastName +

                            " " +

                            itemBenef.mothersLastName

                        }}

                      </p>

                      <p v-else style="font-size: 15px; font-weight: 600; color: #000">

                        HIJ@ MENOR -

                        {{

                            itemBenef.name +

                            " " +

                            itemBenef.lastName +

                            " " +

                            itemBenef.mothersLastName

                        }}

                      </p>

                      <ul v-if="

                        item.beneficiaryType == 'OLDER_CHILD' ||

                        itemBenef.beneficiaryType == 'SPOUSE'

                      ">

                        <li v-if="

                          findDocumentwithComment(

                            itemBenef.documents,

                            'PROFILE_PICTURE'

                          )

                        ">

                          Personales:

                          {{

                              findDocumentwithComment(

                                itemBenef.documents,

                                "PROFILE_PICTURE"

                              ).comment

                          }}

                        </li>

                        <li v-if="itemBenef.laborData">

                          Laborales: {{ itemBenef.laborData.comment }}

                        </li>

                        <li v-if="

                          findDocumentwithComment(

                            itemBenef.documents,

                            'PROOF_OF_ADDRESS'

                          )

                        ">

                          Domicilio:

                          {{

                              findDocumentwithComment(

                                itemBenef.documents,

                                "PROOF_OF_ADDRESS"

                              ).comment

                          }}

                        </li>

                      </ul>

                      <ul v-else>

                        <li v-if="

                          findDocumentwithComment(

                            itemBenef.documents,

                            'PROFILE_PICTURE'

                          )

                        ">

                          Personales:

                          {{

                              findDocumentwithComment(

                                itemBenef.documents,

                                "PROFILE_PICTURE"

                              ).comment

                          }}

                        </li>

                        <li v-if="

                          findDocumentwithComment(

                            itemBenef.documents,

                            'PROOF_OF_ADDRESS'

                          )

                        ">

                          Domicilio:

                          {{

                              findDocumentwithComment(

                                itemBenef.documents,

                                "PROOF_OF_ADDRESS"

                              ).comment

                          }}

                        </li>

                      </ul>

                    </div>



                    <!-- <div v-if="spouseData">

                      <p style="font-size: 15px; font-weight: 600; color: #000;">Cónyuge </p>

                    <ul >

                        <li v-if="comentarios[1].conyugeSol" >

                          {{ comentarios[1].conyugeSol }}

                        </li>

                        <li v-if="comentarios[1].conyugeLab" >

                          {{ comentarios[1].conyugeLab }}

                        </li>

                        <li v-if="comentarios[1].ConyugeDom" >

                          {{ comentarios[1].ConyugeDom }}

                        </li>

                      </ul>

                    </div>



 -->

                  </div>

                </div>

                <div v-else style="

                    font-size: 15px;

                    text-transform: uppercase;

                    padding: 15px;

                  ">

                  <p style="font-size: 15px; font-weight: 600; color: #dc7134">

                    Fecha de envio a correción:

                    {{

                        app.application.editingFrom

                          ? app.application.editingFrom

                          : "Sin Fecha Registrada"

                    }}

                  </p>

                  <p style="font-size: 15px; font-weight: 600; color: #dc7134">

                    Fecha en que el titular realizó la correción:

                    {{

                        app.application.editedAt

                          ? app.application.editedAt

                          : "Sin Fecha Registrada"

                    }}

                  </p>

                  <p style="font-size: 15px; font-weight: 600; color: #000">

                    Titular

                  </p>

                  <ul>

                    <li v-if="comentarios[0].titularSol">

                      {{ comentarios[0].titularSol }}

                    </li>

                    <li v-if="comentarios[0].titularPerso">

                      {{ comentarios[0].titularPerso }}

                    </li>

                    <li v-if="comentarios[0].titularDom">

                      {{ comentarios[0].titularDom }}

                    </li>

                    <li v-if="comentarios[0].titularLab">

                      {{ comentarios[0].titularLab }}

                    </li>

                    <li v-if="comentarios[0].titularFact">

                      {{ comentarios[0].titularFact }}

                    </li>

                  </ul>

                  <p style="font-size: 15px; font-weight: 600; color: #000">

                    Recomendaciones

                  </p>

                  <ul v-for="(item, index) in comentarios[0]

                  .titularRecomendations" :key="index">

                    <li v-if="item">

                      {{ item }}

                    </li>

                  </ul>



                  <div v-if="spouseData">

                    <p style="font-size: 15px; font-weight: 600; color: #000">

                      Cónyuge

                    </p>

                    <ul>

                      <li v-if="comentarios[1].conyugeSol">

                        {{ comentarios[1].conyugeSol }}

                      </li>

                      <li v-if="comentarios[1].conyugeLab">

                        {{ comentarios[1].conyugeLab }}

                      </li>

                      <li v-if="comentarios[1].ConyugeDom">

                        {{ comentarios[1].ConyugeDom }}

                      </li>

                    </ul>

                  </div>



                  <div v-for="(item, index) in beneficiaries" :key="item.beneficiaryType + index">

                    <p v-if="item.beneficiaryType == 'OLDER_CHILD'"

                      style="font-size: 15px; font-weight: 600; color: #000">

                      HIJ@ MAYOR -

                      {{

                          item.name +

                          " " +

                          item.lastName +

                          " " +

                          item.mothersLastName

                      }}

                    </p>

                    <p v-else style="font-size: 15px; font-weight: 600; color: #000">

                      HIJ@ MENOR -

                      {{

                          item.name +

                          " " +

                          item.lastName +

                          " " +

                          item.mothersLastName

                      }}

                    </p>

                    <ul v-if="item.beneficiaryType == 'OLDER_CHILD'">

                      <li v-if="comentarios[index + 2].benefSolCom">

                        {{ comentarios[index + 2].benefSolCom }}

                      </li>

                      <li v-if="comentarios[index + 2].benefLab">

                        {{ comentarios[index + 2].benefLab }}

                      </li>

                      <li v-if="comentarios[index + 2].benefDom">

                        {{ comentarios[index + 2].benefDom }}

                      </li>

                    </ul>

                    <ul v-else>

                      <li v-if="comentarios[index + 2].benefSolCom">

                        {{ comentarios[index + 2].benefSolCom }}

                      </li>

                      <li v-if="comentarios[index + 2].benefDom">

                        {{ comentarios[index + 2].benefDom }}

                      </li>

                    </ul>

                  </div>

                </div>

              </mdb-row>

            </mdb-col>

          </mdb-row>

        </div>

      </Accordion>



      <!--CONYUGE-->

      <Accordion v-if="

        app.maritalStatus == 'MARRIED' &&

        app.application.membership.membershipName == 'Familiar'

      " :key="'conyuge'" id="conyuge" title="Cónyuge" :eventHub="eventHub">

        <!---->

        <div v-if="conyugeOpen" class="accordion-content">

          <AccordionAdmin title="Personales" id="conyugeSol" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="checkToCorrect" class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox" style="float: right">

                      <input v-if="checkToCorrect" type="checkbox" id="conyugeSolCheck"

                        v-model="secciones[1].conyugeSol.check" />

                      <label v-if="checkToCorrect" for="conyugeSolCheck" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[1].conyugeSol.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_BY_PARTNER_SERVICE'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[1].conyugeSol"

                            style="font-size: 15px" :disabled="!secciones[1].conyugeSol.check"></textarea>



                          <Btn v-if="

                            !secciones[1].conyugeSol.save &&

                            secciones[1].conyugeSol.check

                          " :text="'Guardar'" :type="'primary-admin'"

                            @onClick="saveDataUpdate('Personales', 'Conyuge', {})"></Btn>

                        </div>



                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="4">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <img v-if="item.documentType == 'PROFILE_PICTURE'" class="avatar-pic" :src="item.publicURL"

                          alt="Profile Picture" @click="openModal2(item.publicURL, 'Foto conyuge')" />

                        <div v-if="item.documentType == 'PROFILE_PICTURE'" class="zoom-pic"

                          @click="openModal2(item.publicURL, 'Foto titular')"></div>

                      </div>

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].birthDate" md="4">

                      <label for="input_appN" class="form__label">Fecha de nacimiento:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].birthDate"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].birthPlace" md="4">

                      <label for="input_appN" class="form__label">Entidad de nacimiento:</label>

                      <input type="text" id="input_appN" class="form__input" :value="spouseData[0].birthPlace"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="spouseData[0].name" md="4">

                      <label for="input_name" class="form__label">Nombre:</label>

                      <input type="text" id="input_name" class="form__input" :value="spouseData[0].name" disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].lastName" md="4">

                      <label for="input_lastname" class="form__label">Apellido paterno:</label>

                      <input type="text" id="input_lastname" class="form__input" :value="spouseData[0].lastName"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].mothersLastName" md="4">

                      <label for="input_lastname" class="form__label">Apellido materno:</label>

                      <input type="text" id="input_lastname" class="form__input" :value="spouseData[0].mothersLastName"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <!-- <mdb-col md="6">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <label

                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                          for="input_name"

                          class="form__label"

                        >INE/PASAPORTE:</label>

                        <input

                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                          type="text"

                          id="input_name"

                          :value="item.value"

                          class="form__input"

                          disabled

                        />

                      </div>

                    </mdb-col>-->

                    <mdb-col md="6">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <label v-if="item.documentType == 'CURP'" for="input_name" class="form__label">CURP:</label>

                        <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"

                          class="form__input" disabled />

                      </div>

                    </mdb-col>

                    <mdb-col md="4"></mdb-col>

                  </mdb-row>



                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <Btn v-if="

                          item.documentType == 'INE' ||

                          item.documentType == 'PASSPORT'

                        " :text="'IDENTIFICACIÓN OFICIAL'" icon="revisar" :type="'primary-admin'" @onClick="

  openModal(item.publicURL, 'Indentificación Oficial')

"></Btn>

                      </div>

                    </mdb-col>

                    <mdb-col md="3">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <Btn v-if="item.documentType == 'CURP'" :text="'CURP'" icon="revisar" :type="'primary-admin'"

                          @onClick="openModal(item.publicURL, 'CURP')"></Btn>

                      </div>

                    </mdb-col>

                    <mdb-col md="5">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE'" :text="'ACTA DE NACIMIENTO'" icon="revisar"

                          :type="'primary-admin'" @onClick="

                            openModal(item.publicURL, 'Acta de nacimiento')

                          "></Btn>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <AccordionAdmin title="Datos laborales" id="conyugeLab" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="checkToCorrect" class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="checkToCorrect" type="checkbox" id="conyugeLab"

                        v-model="secciones[1].conyugeLab.check" />

                      <label v-if="checkToCorrect" for="conyugeLab" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[1].conyugeLab.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_BY_PARTNER_SERVICE'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form_group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[1].conyugeLab"

                            style="font-size: 15px" :disabled="!secciones[1].conyugeLab.check"></textarea>

                          <Btn v-if="

                            !secciones[1].conyugeLab.save &&

                            secciones[1].conyugeLab.check

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Laborales', 'Conyuge', {})

"></Btn>

                        </div>

                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <label class="form__label">Labora actualmente: </label>

                  <div class="form__check">

                    <span v-if="spouseData[0].laborData.working" style="font-weight: 700; font-size: 15px">

                      Si

                    </span>

                    <span v-else style="font-weight: 700; font-size: 15px">

                      No

                    </span>

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12" v-if="spouseData[0].laborData.working">

                  <mdb-row>

                    <mdb-col v-if="spouseData[0].laborData.company" md="12">

                      <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].laborData.company"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="12">

                      <label for="input_appN" class="form__label">Giro de la empresa:</label>

                      <input type="text" id="input_appN" class="form__input"

                        v-model="spouseData[0].laborData.businessActivity" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="spouseData[0].laborData.addressCompany" md="12">

                      <label for="input_appN" class="form__label">Domicilio de la empresa:</label>

                      <!-- <input

                        type="text"

                        id="input_appN"

                        class="form__input"

                        v-model="spouseData[0].laborData.addressCompany"

                        disabled

                      /> -->

                      <textarea id="input_appN" rows="5" class="form__input"

                        v-model="spouseData[0].laborData.addressCompany" disabled></textarea>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="spouseData[0].laborData.phone" md="4">

                      <label for="input_appN" class="form__label">Teléfono de la empresa:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].laborData.phone"

                        disabled />

                    </mdb-col>



                    <mdb-col v-if="spouseData[0].laborData.phone" md="8">

                      <label for="input_appN" class="form__label">Profesión:

                      </label>

                      <input type="text" id="input_appN" class="form__input"

                        v-model="spouseData[0].laborData.profession" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="12">

                      <label for="input_appN" class="form__label">Puesto que desempeña:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].laborData.position"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

                <mdb-col md="12" v-else>

                  <mdb-row class="mt-3">

                    <mdb-col v-if="spouseData[0].laborData.activityDescription" md="8">

                      <label for="input_appN" class="form__label">A qué se dedica:

                      </label>



                      <textarea id="input_appN" rows="5" class="form__input"

                        v-model="spouseData[0].laborData.activityDescription" readonly></textarea>

                    </mdb-col>



                    <mdb-col v-if="spouseData[0].laborData.phone" md="4">

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row class="mt-3">

                <mdb-col md="6">

                  <div v-for="item in spouseData[0].documents" :key="item.id">

                    <Btn v-if="item.documentType == 'TAX_STATUS_LETTER'" :text="'CONSTANCIA DE SITUACIÓN FISCAL'"

                      icon="revisar" :type="'primary-admin'" @onClick="

                        openModal(

                          item.publicURL,

                          'Constancia de situación fiscal'

                        )

                      "></Btn>

                  </div>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <AccordionAdmin v-if="spouseData[0].personalMail" title="De contacto" id="titularCon" style="padding: 0">

            <div class="accordion-content">

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="8">

                      <label for="input_appN" class="form__label">Correo electrónico:</label>

                      <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].personalMail"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <div v-for="(item, index) in spouseData[0].phones" :key="index">

                      <mdb-col md="9" v-if="item.phoneType == 'Celular'">

                        <label for="input_appN" class="form__label">Télefono celular:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                      <mdb-col v-if="item.phoneType == 'Casa'" md="9">

                        <label for="input_appN" class="form__label">Télefono casa:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                      <mdb-col v-if="item.phoneType == 'Oficina'" md="9">

                        <label for="input_appN" class="form__label">Télefono oficina:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <AccordionAdmin v-if="addressSpouse.length > 0" title="Domicilio" id="titularDom" style="padding: 0">

            <div class="accordion-content">

              <mdb-row class="mb-3">

                <mdb-col md="12">

                  <mdb-row class="corrections-row mb-3">

                    <div v-if="

                      loginUserType == 'PARTNER_SERVICE' &&

                      app.application.applicationStatus ==

                      'DOCUMENTATION_FINISHED'

                    " class="check-corrections">

                      Marcar los datos de este formulario como incorrectos.

                    </div>



                    <div class="t1-checkbox">

                      <input v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " type="checkbox" id="ConyugeDom" v-model="secciones[1].ConyugeDom.check" />

                      <label v-if="

                        loginUserType == 'PARTNER_SERVICE' &&

                        app.application.applicationStatus ==

                        'DOCUMENTATION_FINISHED'

                      " for="ConyugeDom" class="form__label">

                        <span class="check-custom2" style="background-color: white !important"></span>

                      </label>

                      <mdb-popover v-if="

                        secciones[1].ConyugeDom.check ||

                        app.application.applicationStatus ==

                        'IN_EDIT_ACCEPTED'

                      " trigger="click" :options="{ placement: 'right' }">

                        <span slot="header">Comentarios</span>

                        <div class="form__group" slot="body">

                          <textarea class="form-control" rows="15" maxlength="300" v-model="comentarios[1].ConyugeDom"

                            style="font-size: 15px" :disabled="

                              app.application.applicationStatus ==

                              'IN_EDIT_ACCEPTED'

                            "></textarea>

                          <Btn v-if="

                            !secciones[1].ConyugeDom.save &&

                            app.application.applicationStatus !=

                            'IN_EDIT_ACCEPTED'

                          " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Domicilio', 'Conyuge', {})

"></Btn>

                        </div>

                        <button type="button" class="btn btn-edit" style="

                            position: absolute;

                            padding: 0px;

                            margin-top: -1rem;

                          " slot="reference">

                          <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                        </button>

                      </mdb-popover>

                    </div>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <mdb-row>

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Estado:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressSpouse[0].state" disabled />

                    </mdb-col>



                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Ciudad:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressSpouse[0].city" disabled />

                    </mdb-col>

                    <mdb-col md="2">

                      <label for="input_appN" class="form__label">C. P.:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressSpouse[0].zipCode"

                        disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="4">

                      <label for="input_appN" class="form__label">Colonia:</label>

                      <input type="text" id="input_appN" class="form__input" :value="addressSpouse[0].colony"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].address" md="4">

                      <label for="input_appN" class="form__label">Calle:</label>

                      <input type="text" id="input_appN" class="form__input" :value="spouseData[0].address.street"

                        disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].address" md="2">

                      <label for="input_appN" class="form__label">No. Ext.:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="spouseData[0].address.externalNumber" disabled />

                    </mdb-col>

                    <mdb-col v-if="spouseData[0].address" md="2">

                      <label for="input_appN" class="form__label">No. Int.:</label>

                      <input type="text" id="input_appN" class="form__input"

                        :value="spouseData[0].address.interiorNumber" disabled />

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-3">

                    <mdb-col md="8">

                      <div v-for="item in spouseData[0].documents" :key="item.id">

                        <Btn v-if="item.documentType == 'PROOF_OF_ADDRESS'" :text="'Comprobante de domicilio'"

                          icon="revisar" :type="'primary-admin'" @onClick="

                            openModal(

                              item.publicURL,

                              'Comprobante de domicilio'

                            )

                          "></Btn>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </AccordionAdmin>



          <div v-for="(item, index) in spouseData[0].phones" :key="index">

            <AccordionAdmin v-if="item.phoneType == 'Emergency'" title="Contacto de emergencia" id="titularEme"

              style="padding: 0">

              <div class="accordion-content">

                <mdb-row>

                  <mdb-col md="12">

                    <mdb-row>

                      <mdb-col md="12">

                        <label for="input_appN" class="form__label">Nombre del contacto:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.contactName" disabled />

                      </mdb-col>

                    </mdb-row>

                    <mdb-row class="mt-3">

                      <mdb-col md="4">

                        <label for="input_appN" class="form__label">Parentesco:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"

                          disabled />

                      </mdb-col>

                      <mdb-col md="4">

                        <label for="input_appN" class="form__label">Télefono celular:</label>

                        <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                      </mdb-col>

                    </mdb-row>

                  </mdb-col>

                </mdb-row>

              </div>

            </AccordionAdmin>

          </div>



          <mdb-row style="padding: 2rem">

            <mdb-col>

              <mdb-row>

                <nav>

                  <ul class="t1-navigation">

                    <li :class="

                      indexSpouseTab === 1 ? 't1-navigation--active' : ''

                    ">

                      <a @click="indexSpouseTab = 1">Investigación JusWho</a>

                    </li>

                    <li v-show="hasPermissionToDownloadDocuments" :class="

                      indexSpouseTab === 2 ? 't1-navigation--active' : ''

                    ">

                      <a @click="indexSpouseTab = 2">Descargar documentos</a>

                    </li>

                  </ul>

                </nav>

              </mdb-row>



              <mdb-row v-show="

                indexSpouseTab === 1 &&

                app.application.applicationStatus !== 'CREATED'

              ">

                <div v-if="spouseData[0].investigations.length > 0" style="width: 100%; background: white">

                  <mdb-row>

                    <mdb-col md="6"></mdb-col>

                    <mdb-col md="6">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important; color: #dc7134">Fecha de

                          Investigación:

                          {{ spouseData[0].investigations[0].createdAt }}</label>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="6"></mdb-col>

                    <mdb-col md="6">

                      <div class="form__group mt-2">

                        <div v-if="

                          fileConExtra == null &&

                          app.application.applicationStatus ==

                          'IN_REVIEW_BY_PARTNER_SERVICE'

                        " class="form__group">

                          <label for="curp-input" class="btn-label">

                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />

                            SUBIR INVESTIGACIÓN EXTRA

                          </label>

                          <input type="file" accept="application/pdf" name="file" id="curp-input"

                            style="visibility: hidden" @change="uploadConExtra" />

                        </div>



                        <div v-if="fileConExtra != null" class="input-group">

                          <btn v-if="fileConExtraBase64 != null" :text="'¡GUARDAR INVESTIGACIÓN EXTRA!'"

                            :type="'primary-admin'" style="float: left" @onClick="saveConExtraInvestigation"></btn>

                          <btn v-else :text="'¡INVESTIGACIÓN EXTRA GUARDADA!'" :type="'primary-admin-success'"

                            style="float: left"></btn>

                          <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"

                            @click="

                              openModal(

                                fileConExtra,

                                'Investigación Extra Cónyuge'

                              )

                            " />

                        </div>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Personales</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Fecha de nacimiento:</label>

                            <input type="text" id="input_name" class="form__input" v-model="

                              spouseData[0].investigations[0].birthDate

                            " disabled />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Denominación:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0].denomination

                            " />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Identificación:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0].identification

                            " />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Identificación Tributaria:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0]

                                .taxIdentification

                            " />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Otra Identificación:</label>

                            <input v-if="

                              spouseData[0].investigations[0]

                                .otherIdentification != ''

                            " type="text" id="input_name" class="form__input" disabled v-model="

  spouseData[0].investigations[0]

    .otherIdentification

" />

                            <input v-else type="text" id="input_name" class="form__input" disabled

                              :value="'NO DISPONIBLE'" />

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Laborales</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Cargo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="spouseData[0].investigations[0].position" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Lugar de trabajo:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0].workplace

                            " />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="6">

                            <label for="input_name" class="form__label">Dirección de trabajo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="spouseData[0].investigations[0].address" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Enlace a página web:</label>

                            <a style="font-size: 18px" :href="spouseData[0].investigations[0].link">Sitio web</a>

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row class="mt-5" style="margin-left: 5%">

                    <mdb-col md="12">

                      <div class="form__group">

                        <label class="form__label" style="cursor: unset !important">| Tipo de persona</label>

                      </div>

                    </mdb-col>

                    <mdb-col md="12" style="margin-left: -5%">

                      <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 3rem;

                        ">

                        <mdb-row>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Tipo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="spouseData[0].investigations[0].type" />

                          </mdb-col>

                          <mdb-col v-if="spouseData[0].investigations[0].type == 'TER'" md="4">

                            <label for="input_name" class="form__label">SubTipo:</label>

                            <input type="text" id="input_name" class="form__input" disabled

                              v-model="spouseData[0].investigations[0].subType" />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Estado:</label>

                            <input type="text" id="input_name" class="form__input"

                              v-model="spouseData[0].investigations[0].state" disabled />

                          </mdb-col>

                          <mdb-col v-if="

                            spouseData[0].investigations[0].state ==

                            'INACTIVO'

                          " md="4">

                            <label for="input_name" class="form__label">Finalización del cargo:</label>

                            <input type="text" id="input_name" class="form__input" :value="

                              spouseData[0].investigations[0]

                                .terminationOfOffice

                            " disabled />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Lista:</label>

                            <input type="text" id="input_name" class="form__input"

                              v-model="spouseData[0].investigations[0].list" disabled />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">País de la lista:</label>

                            <input v-if="

                              spouseData[0].investigations[0].countryList !=

                              ''

                            " type="text" id="input_name" class="form__input" disabled v-model="

  spouseData[0].investigations[0].countryList

" />

                            <input v-else type="text" id="input_name" class="form__input" disabled

                              :value="'NO DISPONIBLE'" />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Código del individuo:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0].individualCode

                            " />

                          </mdb-col>

                        </mdb-row>

                        <mdb-row class="mt-4">

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Exactitud denominación:</label>

                            <input v-if="

                              spouseData[0].investigations[0]

                                .namingAccuracy != ''

                            " type="text" id="input_name" class="form__input" v-model="

  spouseData[0].investigations[0].namingAccuracy

" disabled />

                            <input v-else type="text" id="input_name" class="form__input" :value="'NO DISPONIBLE'"

                              disabled />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_name" class="form__label">Exactitud indentificación:</label>

                            <input type="text" id="input_name" class="form__input" disabled v-model="

                              spouseData[0].investigations[0]

                                .identificationAccuracy

                            " />

                          </mdb-col>

                        </mdb-row>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </div>

                <div v-else class="divClass">

                  <mdb-row>

                    <mdb-col md="12">

                      <div class="form__group mt-2">

                        <div v-if="

                          fileConExtra == null &&

                          app.application.applicationStatus ==

                          'IN_REVIEW_BY_PARTNER_SERVICE'

                        " class="form__group">

                          <label for="curp-input" class="btn-label">

                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />

                            SUBIR INVESTIGACIÓN EXTRA

                          </label>

                          <input type="file" accept="application/pdf" name="file" id="curp-input"

                            style="visibility: hidden" @change="uploadConExtra" />

                        </div>



                        <div v-if="fileConExtra != null" class="input-group">

                          <btn v-if="fileConExtraBase64 != null" :text="'¡GUARDAR INVESTIGACIÓN EXTRA!'"

                            :type="'primary-admin'" style="float: left" @onClick="saveConExtraInvestigation"></btn>

                          <btn v-else :text="'¡INVESTIGACIÓN EXTRA GUARDADA!'" :type="'primary-admin-success'"

                            style="float: left"></btn>

                          <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/watch-unpressed-btn.svg'"

                            @click="

                              openModal(

                                fileConExtra,

                                'Investigación Extra Cónyuge'

                              )

                            " />

                        </div>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <!-- <mdb-row v-if="

                    spouseData[0].investigationResultMessage !=

                    'Sin envío a investigación de PDL'

                  ">

                    <p class="mt-5" style="font-size: 18px; font-weight: 600; color: #828282">

                      <img src="/img/icons/approved-default.svg" alt="Aproved" />

                      SOLICITANTE CON HISTORIAL LIMPIO

                    </p>



                    <p style="text-align: justify">

                      <b>El resultado de investigación para este Solicitante ha

                        sido realizado y no se han encontrado datos como persona

                        PEP (Persona Expuesta Políticamente) o TER

                        (Terrorista)</b>, así como delictivos que deban tomarse en cuenta para su

                      proceso de admisión.

                    </p>

                  </mdb-row> -->

                </div>

              </mdb-row>

              <mdb-row v-show="

                indexSpouseTab === 2 && hasPermissionToDownloadDocuments

              " class="m-1 w-100">

                <mdb-col col="12">

                  <div class="bg-white p-4" style="border: 1px solid #3a8a65; border-radius: 5px">

                    <h3 class="h3 font-weight-bold mb-4">Cónyuge</h3>



                    <div v-for="item in filterDocumentsForCheck(

                      spouseData[0].documents,

                      'documentType'

                    )" :key="item.id" class="form__group">

                      <div class="t1-checkbox ml-5">

                        <input v-model="selectedDocuments.spouse[item.documentType]" type="checkbox"

                          :id="`SPOUSE_${item.documentType}`" />

                        <label :for="`SPOUSE_${item.documentType}`" class="form__label">

                          <span class="check-custom"></span>

                          {{ LIST_DOCUMENTS_TRANSLATE[item.documentType] }}

                        </label>

                      </div>

                    </div>



                    <div class="mt-5 d-flex flex-row align-items-center">

                      <Btn @onClick="

                        downloadFiles({

                          beneficiaryId: spouseData[0].id,

                          type: 'spouse',

                        })

                      " class="mr-3" :text="'DESCARGAR SELECCIONADOS'" icon="download" :type="'primary-admin'"></Btn>

                      <Btn @onClick="

                        downloadFiles(

                          { beneficiaryId: spouseData[0].id },

                          getTypesFromDocuments(spouseData[0].documents)

                        )

                      " :text="'DESCARGAR TODOS'" icon="download" :type="'primary-admin'"></Btn>

                    </div>

                  </div>

                </mdb-col>

              </mdb-row>

            </mdb-col>

          </mdb-row>

        </div>

      </Accordion>



      <!-- BENEFICIARIOS-->

      <div v-if="beneficiaries != null">

        <div v-for="(benef, index) in beneficiaries" :key="benef.id">

          <Accordion id="beneficiarios" :index="index" :key="benef.id" :title="

            benef.beneficiaryType == 'OLDER_CHILD'

              ? 'Hij@ mayor'

              : 'Hij@ menor'

          " :eventHub="eventHub">

            <div v-if="beneficiariesOpen" class="accordion-content">

              <AccordionAdmin title="Personales" :id="'beneficiary_' + index" style="padding: 0">

                <div class="accordion-content">

                  <mdb-row class="mb-3">

                    <mdb-col md="12">

                      <mdb-row class="corrections-row mb-3">

                        <div v-if="

                          loginUserType == 'PARTNER_SERVICE' &&

                          app.application.applicationStatus ==

                          'DOCUMENTATION_FINISHED'

                        " class="check-corrections">

                          Marcar los datos de este formulario como incorrectos.

                        </div>



                        <div class="t1-checkbox">

                          <input v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " type="checkbox" :id="'benefSol' + index" v-model="secciones[index + 2].bSol.check" />

                          <label v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " :for="'benefSol' + index" class="form__label">

                            <span class="check-custom2" style="background-color: white !important"></span>

                          </label>

                          <mdb-popover v-if="

                            secciones[index + 2].bSol.check ||

                            app.application.applicationStatus ==

                            'IN_EDIT_ACCEPTED'

                          " trigger="click" :options="{ placement: 'right' }">

                            <span slot="header">Comentarios</span>

                            <div slot="body" class="form__group">

                              <textarea class="form-control" rows="15" maxlength="300"

                                v-model="comentarios[index + 2].benefSol" style="font-size: 15px" :disabled="

                                  app.application.applicationStatus ==

                                  'IN_EDIT_ACCEPTED'

                                "></textarea>

                              <Btn v-if="

                                !secciones[index + 2].bSol.save &&

                                app.application.applicationStatus !=

                                'IN_EDIT_ACCEPTED'

                              " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Personales', 'Beneficiario', {

    index: index,

    benef: benef,

  })

"></Btn>

                            </div>

                            <button type="button" class="btn btn-edit" style="

                                position: absolute;

                                padding: 0px;

                                margin-top: -1rem;

                              " slot="reference">

                              <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                            </button>

                          </mdb-popover>

                        </div>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="12">

                      <mdb-row>

                        <mdb-col md="4">

                          <div v-for="item in benef.documents" :key="item.id">

                            <img v-if="item.documentType == 'PROFILE_PICTURE'" class="avatar-pic" :src="item.publicURL"

                              alt="Profile Picture" @click="

                                openModal2(item.publicURL, 'Foto beneficiario')

                              " />

                            <div v-if="item.documentType == 'PROFILE_PICTURE'" class="zoom-pic" @click="

                              openModal2(item.publicURL, 'Foto titular')

                            "></div>

                          </div>

                        </mdb-col>

                        <mdb-col v-if="benef.birthDate" md="4">

                          <label for="input_appN" class="form__label">Fecha de nacimiento:</label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.birthDate" disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.birthPlace" md="4">

                          <label for="input_appN" class="form__label">Entidad de nacimiento:</label>

                          <input type="text" id="input_appN" class="form__input" :value="benef.birthPlace" disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col v-if="benef.name" md="4">

                          <label for="input_name" class="form__label">Nombre:</label>

                          <input type="text" id="input_name" class="form__input" :value="benef.name" disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.lastName" md="4">

                          <label for="input_lastname" class="form__label">Apellido paterno:</label>

                          <input type="text" id="input_lastname" class="form__input" :value="benef.lastName" disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.mothersLastName" md="4">

                          <label for="input_lastname" class="form__label">Apellido materno:</label>

                          <input type="text" id="input_lastname" class="form__input" :value="benef.mothersLastName"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <!-- <mdb-col md="6">

                          <div v-for="item in benef.documents" :key="item.id">

                            <label

                                    v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                                    for="input_name"

                                    class="form__label"

                            >INE/PASAPORTE:</label>

                            <input

                                    v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"

                                    type="text"

                                    id="input_name"

                                    :value="item.value"

                                    class="form__input"

                                    disabled

                            />

                          </div>

                        </mdb-col>-->

                        <mdb-col md="6">

                          <div v-for="item in benef.documents" :key="item.id">

                            <label v-if="item.documentType == 'CURP'" for="input_name" class="form__label">CURP:</label>

                            <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"

                              class="form__input" disabled />

                          </div>

                        </mdb-col>

                        <mdb-col md="4"></mdb-col>

                      </mdb-row>



                      <mdb-row class="mt-3">

                        <mdb-col md="4">

                          <div v-for="item in benef.documents" :key="item.id">

                            <Btn v-if="

                              item.documentType == 'INE' ||

                              item.documentType == 'PASSPORT'

                            " :text="'IDENTIFIACIÓN OFICIAL'" icon="revisar" :type="'primary-admin'" @onClick="

  openModal(item.publicURL, 'Indentificación')

"></Btn>

                          </div>

                        </mdb-col>

                        <mdb-col md="3">

                          <div v-for="item in benef.documents" :key="item.id">

                            <Btn v-if="item.documentType == 'CURP'" :text="'CURP'" icon="revisar"

                              :type="'primary-admin'" @onClick="openModal(item.publicURL, 'CURP')"></Btn>

                          </div>

                        </mdb-col>

                        <mdb-col md="5">

                          <div v-for="item in benef.documents" :key="item.id">

                            <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE'" :text="'ACTA DE NACIMIENTO'"

                              icon="revisar" :type="'primary-admin'" @onClick="

                                openModal(item.publicURL, 'Acta de nacimiento')

                              "></Btn>

                          </div>

                        </mdb-col>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                </div>

              </AccordionAdmin>



              <AccordionAdmin v-if="addressBenef.length > 0 && benef.address" title="Domicilio" id="titularDom"

                style="padding: 0">

                <div class="accordion-content">

                  <mdb-row class="mb-3">

                    <mdb-col md="12">

                      <mdb-row class="corrections-row mb-3">

                        <div v-if="

                          loginUserType == 'PARTNER_SERVICE' &&

                          app.application.applicationStatus ==

                          'DOCUMENTATION_FINISHED'

                        " class="check-corrections">

                          Marcar los datos de este formulario como incorrectos.

                        </div>



                        <div class="t1-checkbox">

                          <input v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " type="checkbox" :id="'benefDom' + index" v-model="secciones[index + 2].benefDom.check" />

                          <label v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " :for="'benefDom' + index" class="form__label">

                            <span class="check-custom2" style="background-color: white !important"></span>

                          </label>

                          <mdb-popover v-if="

                            secciones[index + 2].benefDom.check ||

                            app.application.applicationStatus ==

                            'IN_EDIT_ACCEPTED'

                          " trigger="click" :options="{ placement: 'right' }">

                            <span slot="header">Comentarios</span>

                            <div slot="body" class="form__group">

                              <textarea class="form-control" rows="15" maxlength="300"

                                v-model="comentarios[index + 2].benefDom" style="font-size: 15px" :disabled="

                                  app.application.applicationStatus ==

                                  'IN_EDIT_ACCEPTED'

                                "></textarea>

                              <Btn v-if="

                                !secciones[index + 2].benefDom.save &&

                                app.application.applicationStatus !=

                                'IN_EDIT_ACCEPTED'

                              " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Domicilio', 'Beneficiario', {

    index: index,

    benef: benef,

  })

"></Btn>

                            </div>

                            <button type="button" class="btn btn-edit" style="

                                position: absolute;

                                padding: 0px;

                                margin-top: -1rem;

                              " slot="reference">

                              <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                            </button>

                          </mdb-popover>

                        </div>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="12">

                      <mdb-row>

                        <mdb-col md="4">

                          <label for="input_appN" class="form__label">Estado:</label>

                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[index].state"

                            disabled />

                        </mdb-col>



                        <mdb-col md="4">

                          <label for="input_appN" class="form__label">Ciudad:</label>

                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[index].city"

                            disabled />

                        </mdb-col>

                        <mdb-col md="2">

                          <label for="input_appN" class="form__label">C. P.:</label>

                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[index].zipCode"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col md="4">

                          <label for="input_appN" class="form__label">Colonia:</label>

                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[index].colony"

                            disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.address" md="4">

                          <label for="input_appN" class="form__label">Calle:</label>

                          <input type="text" id="input_appN" class="form__input" :value="benef.address.street"

                            disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.address" md="2">

                          <label for="input_appN" class="form__label">No. Ext.:</label>

                          <input type="text" id="input_appN" class="form__input" :value="benef.address.externalNumber"

                            disabled />

                        </mdb-col>

                        <mdb-col v-if="benef.address" md="2">

                          <label for="input_appN" class="form__label">No. Int.:</label>

                          <input type="text" id="input_appN" class="form__input" :value="benef.address.interiorNumber"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col md="8">

                          <div v-for="item in benef.documents" :key="item.id">

                            <Btn v-if="item.documentType == 'PROOF_OF_ADDRESS'" :text="'Comprobante de domicilio'"

                              icon="revisar" :type="'primary-admin'" @onClick="

                                openModal(

                                  item.publicURL,

                                  'Comprobante de domicilio'

                                )

                              "></Btn>

                          </div>

                        </mdb-col>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                </div>

              </AccordionAdmin>



              <AccordionAdmin v-if="benef.personalMail" title="De contacto" id="titularCon" style="padding: 0">

                <div class="accordion-content">

                  <mdb-row>

                    <mdb-col md="12">

                      <mdb-row>

                        <mdb-col md="8">

                          <label for="input_appN" class="form__label">Correo electrónico:</label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.personalMail"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <div v-for="(item, index) in benef.phones" :key="index">

                          <mdb-col md="9" v-if="item.phoneType == 'Celular'">

                            <label for="input_appN" class="form__label">Télefono celular:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                          </mdb-col>

                          <mdb-col v-if="item.phoneType == 'Casa'" md="9">

                            <label for="input_appN" class="form__label">Télefono casa:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                          </mdb-col>

                          <mdb-col v-if="item.phoneType == 'Oficina'" md="9">

                            <label for="input_appN" class="form__label">Télefono oficina:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                          </mdb-col>

                        </div>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                </div>

              </AccordionAdmin>



              <div v-for="(item, index) in benef.phones" :key="index">

                <AccordionAdmin v-if="item.phoneType == 'Emergency'" title="Contacto de emergencia" id="titularEme"

                  style="padding: 0">

                  <div class="accordion-content">

                    <mdb-row>

                      <mdb-col md="12">

                        <mdb-row>

                          <mdb-col md="12">

                            <label for="input_appN" class="form__label">Nombre del contacto:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.contactName" disabled />

                          </mdb-col>



                          <!-- <mdb-col md="4">

                          <label for="input_appN" class="form__label">Apellido paterno:</label>

                          <input type="text" id="input_appN" class="form__input" :value="titularEmergencia.contactName" disabled />

                        </mdb-col>

                        <mdb-col md="4">

                          <label for="input_appN" class="form__label">Apellido materno:</label>

                          <input type="text" id="input_appN" class="form__input" :value="titularEmergencia.contactName" disabled />

                          </mdb-col>-->

                        </mdb-row>

                        <mdb-row class="mt-3">

                          <mdb-col md="4">

                            <label for="input_appN" class="form__label">Parentesco:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"

                              disabled />

                          </mdb-col>

                          <mdb-col md="4">

                            <label for="input_appN" class="form__label">Télefono celular:</label>

                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />

                          </mdb-col>

                        </mdb-row>

                      </mdb-col>

                    </mdb-row>

                  </div>

                </AccordionAdmin>

              </div>



              <AccordionAdmin v-if="benef.laborData" title="Datos laborales" id="benefLaborData" style="padding: 0">

                <div class="accordion-content">

                  <mdb-row class="mb-3">

                    <mdb-col md="12">

                      <mdb-row class="corrections-row mb-3">

                        <div v-if="

                          loginUserType == 'PARTNER_SERVICE' &&

                          app.application.applicationStatus ==

                          'DOCUMENTATION_FINISHED'

                        " class="check-corrections">

                          Marcar los datos de este formulario como incorrectos.

                        </div>

                        <div class="t1-checkbox">

                          <input v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " type="checkbox" :id="'benefLab' + index" v-model="secciones[index + 2].benefLab.check" />

                          <label v-if="

                            loginUserType == 'PARTNER_SERVICE' &&

                            app.application.applicationStatus ==

                            'DOCUMENTATION_FINISHED'

                          " :for="'benefLab' + index" class="form__label">

                            <span class="check-custom2" style="background-color: white !important"></span>

                          </label>

                          <mdb-popover v-if="

                            secciones[index + 2].benefLab.check ||

                            app.application.applicationStatus ==

                            'IN_EDIT_ACCEPTED'

                          " trigger="click" :options="{ placement: 'right' }">

                            <span slot="header">Comentarios</span>

                            <div slot="body" class="form__group">

                              <textarea class="form-control" rows="15" maxlength="300"

                                v-model="comentarios[index + 2].benefLab" style="font-size: 15px" :disabled="

                                  app.application.applicationStatus ==

                                  'IN_EDIT_ACCEPTED'

                                "></textarea>

                              <Btn v-if="

                                !secciones[index + 2].benefLab.save &&

                                app.application.applicationStatus !=

                                'IN_EDIT_ACCEPTED'

                              " :text="'Guardar'" :type="'primary-admin'" @onClick="

  saveDataUpdate('Laborales', 'Beneficiario', {

    index: index,

    benef: benef,

  })

"></Btn>

                            </div>

                            <button type="button" class="btn btn-edit" style="

                                position: absolute;

                                padding: 0px;

                                margin-top: -1rem;

                              " slot="reference">

                              <img :src="'/img/icons/btn_coment.svg'" alt="icon comentar" />

                            </button>

                          </mdb-popover>

                        </div>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="12">

                      <label class="form__label">Labora actualmente: </label>

                      <div class="form__check">

                        <span v-if="benef.laborData.working" style="font-weight: 700; font-size: 15px">

                          Si

                        </span>

                        <span v-else style="font-weight: 700; font-size: 15px">

                          No

                        </span>

                      </div>

                    </mdb-col>

                  </mdb-row>

                  <mdb-row>

                    <mdb-col md="12" v-if="benef.laborData.working">

                      <mdb-row>

                        <mdb-col v-if="benef.laborData.company" md="12">

                          <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.laborData.company"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col md="12">

                          <label for="input_appN" class="form__label">Giro de la empresa:</label>

                          <input type="text" id="input_appN" class="form__input"

                            v-model="benef.laborData.businessActivity" disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col v-if="benef.laborData.addressCompany" md="12">

                          <label for="input_appN" class="form__label">Domicilio de la empresa:</label>

                          <!-- <input

                        type="text"

                        id="input_appN"

                        class="form__input"

                        v-model="benef.laborData.addressCompany"

                        disabled

                      /> -->

                          <textarea id="input_appN" rows="5" class="form__input"

                            v-model="benef.laborData.addressCompany" disabled></textarea>

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col v-if="benef.laborData.phone" md="4">

                          <label for="input_appN" class="form__label">Teléfono de la empresa:</label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.laborData.phone"

                            disabled />

                        </mdb-col>



                        <mdb-col v-if="benef.laborData.phone" md="8">

                          <label for="input_appN" class="form__label">Profesión:

                          </label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.laborData.profession"

                            disabled />

                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-3">

                        <mdb-col md="12">

                          <label for="input_appN" class="form__label">Puesto que desempeña:</label>

                          <input type="text" id="input_appN" class="form__input" v-model="benef.laborData.position"

                            disabled />

                        </mdb-col>

                      </mdb-row>



                      <mdb-row class="mt-3">

                        <mdb-col md="6">

                          <div v-for="item in benef.documents" :key="item.id">

                            <Btn v-if="item.documentType == 'TAX_STATUS_LETTER'"

                              :text="'CONSTANCIA DE SITUACIÓN FISCAL'" icon="revisar" :type="'primary-admin'" @onClick="

                                openModal(

                                  item.publicURL,

                                  'Constancia de situación fiscal'

                                )

                              "></Btn>

                          </div>

                        </mdb-col>

                      </mdb-row>

                    </mdb-col>

                    <mdb-col md="12" v-else>

                      <mdb-row class="mt-3">

                        <mdb-col v-if="benef.laborData.activityDescription" md="8">

                          <label for="input_appN" class="form__label">A qué se dedica:

                          </label>



                          <textarea id="input_appN" rows="5" class="form__input"

                            v-model="benef.laborData.activityDescription" readonly></textarea>

                        </mdb-col>

                      </mdb-row>

                    </mdb-col>

                  </mdb-row>

                </div>

              </AccordionAdmin>



              <mdb-row style="padding: 2rem">

                <mdb-col>

                  <mdb-row>

                    <nav>

                      <ul class="t1-navigation">

                        <li v-show="hasPermissionToDownloadDocuments" :class="

                          indexChildTab === 1 ? 't1-navigation--active' : ''

                        ">

                          <a @click="indexChildTab = 1">Descargar documentos</a>

                        </li>

                      </ul>

                    </nav>

                  </mdb-row>



                  <mdb-row v-show="

                    indexChildTab === 1 && hasPermissionToDownloadDocuments

                  " class="m-1 w-100">

                    <mdb-col col="12">

                      <div class="bg-white p-4" style="border: 1px solid #3a8a65; border-radius: 5px">

                        <h3 class="h3 font-weight-bold mb-4">

                          {{

                              benef.beneficiaryType === "OLDER_CHILD"

                                ? "HIJ@ MAYOR"

                                : "HIJ@ MENOR"

                          }}

                        </h3>



                        <div v-for="item in filterDocumentsForCheck(

                          benef.documents,

                          'documentType'

                        )" :key="item.id" class="form__group">

                          <div class="t1-checkbox ml-5">

                            <input v-model="

                              selectedDocuments[

                              benef.beneficiaryType.toLowerCase()

                              ][item.documentType]

                            " type="checkbox" :id="`${benef.beneficiaryType}_${item.documentType}`" />

                            <label :for="`${benef.beneficiaryType}_${item.documentType}`" class="form__label">

                              <span class="check-custom"></span>

                              {{ LIST_DOCUMENTS_TRANSLATE[item.documentType] }}

                            </label>

                          </div>

                        </div>



                        <div class="mt-5 d-flex flex-row align-items-center">

                          <Btn @onClick="

                            downloadFiles({

                              beneficiaryId: benef.id,

                              type: benef.beneficiaryType.toLowerCase(),

                            })

                          " class="mr-3" :text="'DESCARGAR SELECCIONADOS'" icon="download" :type="'primary-admin'">

                          </Btn>

                          <Btn @onClick="

                            downloadFiles(

                              { beneficiaryId: benef.id },

                              getTypesFromDocuments(spouseData[0].documents)

                            )

                          " :text="'DESCARGAR TODOS'" icon="download" :type="'primary-admin'"></Btn>

                        </div>

                      </div>

                    </mdb-col>

                  </mdb-row>

                </mdb-col>

              </mdb-row>

            </div>

          </Accordion>

        </div>

      </div>



      <!-- COMENTARIOS PARA EL COMITE-->

      <mdb-row v-if="

        loginUserType == 'PARTNER_SERVICE' ||

        loginUserType == 'SALES' ||

        loginUserType == 'COMMITTEE'

      " class="mt-3" style="padding: 2rem; background: #fff">

        <mdb-col md="12">

          <mdb-row>

            <span style="font-size: 18px; font-weight: bold; color: #285f46">COMENTARIOS AL COMITÉ</span>

          </mdb-row>



          <mdb-row class="mt-3">

            <div style="font-size: 14px; font-weight: 600; color: #dc7134">

              {{

                  app.application.comments.length > 0

                    ? app.application.comments[0].user

                    : ""

              }}

              <span style="font-size: 12px; color: rgba(43, 51, 42, 0.5)">{{

                  app.application.comments.length > 0

                    ? app.application.comments[0].createdAt

                    : ""

              }}</span>

            </div>

            <quill-editor v-if="editableTextArea"

              v-model="commentToCommite"

              :options="editorOptions"

              style="width: 100%;">

            </quill-editor>

            <div v-else

              class="form-control comment-html-viewer"

              style="font-size: 15px; color: #000; border-radius: 1px; min-height: 300px; max-height: 60vh; overflow-y: auto; padding: 12px; background: #f9f9f9;"

              v-html="commentHTML">

            </div>

          </mdb-row>

        </mdb-col>

      </mdb-row>

      <div v-if="loginUserType == 'PARTNER_SERVICE'" style="display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 8px; margin-top: 1rem;">

        <Btn :text="'Guardar comentarios'" :type="

          app.application.applicationStatus == 'IN_REVIEW_BY_PARTNER_SERVICE' ||

          app.application.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE'

            ? 'primary-admin'

            : 'disabled-admin'

        " @onClick="

          app.application.applicationStatus == 'IN_REVIEW_BY_PARTNER_SERVICE' ||

          app.application.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE'

            ? saveComments()

            : null

        "></Btn>

        <Btn :text="'Enviar aviso de corrección al solicitante'" :type="

          updateApplication.id == null ? 'disabled-admin' : 'primary-admin'

        " @onClick="updateApplication.id == null ? null : $refs.toUpdate.toggleModal()"></Btn>

        <Btn :text="'Enviar a Comité'" :type="

          app.application.applicationStatus == 'IN_REVIEW_BY_PARTNER_SERVICE'

            ? 'primary-admin'

            : 'disabled-admin'

        " @onClick="

          app.application.applicationStatus == 'IN_REVIEW_BY_PARTNER_SERVICE'

            ? $refs.toCom.toggleModal()

            : null

        "></Btn>

        <Btn :text="'Finalizar Solicitud'" :type="

          app.application.applicationStatus == 'DOCUMENTATION_FINISHED'

            ? 'primary-admin'

            : 'disabled-admin'

        " @onClick="

          app.application.applicationStatus == 'DOCUMENTATION_FINISHED'

            ? $refs.toFinish.toggleModal()

            : null

        "></Btn>

      </div>

    </div>

    <!--accordion-section-->

    <Popup size="lg-extra2" ref="confirm" :title="titleModal">

      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh">

        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>

      </div>

      <div class="accordion__button">

        <btn style="float: left" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />

      </div>

    </Popup>



    <Popup size="md-mod2" ref="profile" :title="titleModal">

      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 95%">

        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>

      </div>

      <div class="accordion__button">

        <btn style="float: left" text="CERRAR" @onClick="$refs.profile.toggleModal()" type="primary-block" />

      </div>

    </Popup>



    <Popup size="sm-mod2" ref="toUpdate">

      <div class="text-left">

        <mdb-row>

          <mdb-col>

            <mdb-row>

              <div style="

                  font-size: 19px;

                  font-weight: 600;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  text-align: center;

                  color: #dc7134;

                ">

                ¡ATENCIÓN ESTÁS A PUNTO DE ENVIAR A CORRECCIÓN LA SOLICITUD!

              </div>

            </mdb-row>

            <mdb-row class="mt-5">

              <div style="

                  font-size: 17px;

                  font-weight: normal;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  color: #4f4f4f;

                  text-align: center;

                  padding: 0rem 2rem;

                ">

                Se dará aviso al solicitante para que actualice los datos

                marcados, la solicitud cambiará de estatus y los comentarios ya

                no los podrás cambiar ni editar.

              </div>

            </mdb-row>

            <mdb-row style="margin-top: 5rem">

              <div class="divLine"></div>

            </mdb-row>

            <mdb-row class="mt-3">

              <div style="margin-left: 20%">

                <Btn @onClick="toUpdateApplication()" :text="'Aceptar'" :type="'primary-admin'" style="float: right">

                </Btn>

                <Btn @onClick="$refs.toUpdate.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"

                  style="float: right; margin-right: 1rem"></Btn>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>



    <Popup size="sm-mod2" ref="saveR">

      <div class="text-left">

        <mdb-row>

          <mdb-col>

            <mdb-row>

              <div style="

                  font-size: 19px;

                  font-weight: 600;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  text-align: center;

                  color: #dc7134;

                ">

                !ATENCIÓN ESTAS A PUNTO DE GUARDAR LOS COMENTARIOS PARA LAS

                RECOMENDACIONES!

              </div>

            </mdb-row>

            <mdb-row class="mt-5">

              <div style="

                  font-size: 17px;

                  font-weight: normal;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  color: #4f4f4f;

                  text-align: center;

                  padding: 0rem 2rem;

                ">

                Los comentarios podras editarlos las veces que puedas necesitar,

                mientras la solicitud este en revisión por atención a socios.

              </div>

            </mdb-row>

            <mdb-row style="margin-top: 5rem">

              <div class="divLine"></div>

            </mdb-row>

            <mdb-row class="mt-3">

              <div style="margin-left: 20%">

                <Btn @onClick="saveRecomendations" :text="'Aceptar'" :type="'primary-admin'" style="float: right"></Btn>

                <Btn @onClick="$refs.saveR.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"

                  style="float: right; margin-right: 1rem"></Btn>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>



    <Popup size="sm" ref="toCom">

      <div class="text-left">

        <mdb-row>

          <mdb-col>

            <mdb-row>

              <div style="

                  font-size: 19px;

                  font-weight: 600;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  text-align: center;

                  color: #dc7134;

                ">

                ¿ESTÁS SEGUR@ DE ENVIAR LA SOLICITUD A COMITÉ?

              </div>

            </mdb-row>

            <mdb-row class="mt-5">

              <div style="

                  font-size: 17px;

                  font-weight: normal;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  color: #4f4f4f;

                  text-align: center;

                  padding: 0rem 2rem;

                ">

                La solicitud se colocará en estatus en Revisión por Comité, una

                vez colocado este estatus no se podrá modificar.

              </div>

            </mdb-row>

            <mdb-row style="margin-top: 5rem">

              <div class="divLine"></div>

            </mdb-row>

            <mdb-row class="mt-3">

              <div style="margin-left: 20%">

                <Btn @onClick="checkBefore" :text="'Aceptar'" :type="'primary-admin'" style="float: right"></Btn>

                <Btn @onClick="$refs.toCom.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"

                  style="float: right; margin-right: 1rem"></Btn>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>



    <Popup size="sm" ref="toFinish">

      <div class="text-left">

        <mdb-row>

          <mdb-col>

            <mdb-row>

              <div style="

                  font-size: 19px;

                  font-weight: 600;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  text-align: center;

                  color: #dc7134;

                ">

                ¿ESTÁS SEGUR@ QUE DESEAS FINALIZAR LA SOLICITUD DE ADMISIÓN?

              </div>

            </mdb-row>

            <mdb-row class="mt-5">

              <div style="

                  font-size: 17px;

                  font-weight: normal;

                  font-stretch: normal;

                  font-style: normal;

                  line-height: normal;

                  letter-spacing: normal;

                  color: #4f4f4f;

                  text-align: center;

                  padding: 0rem 2rem;

                ">

                Al realizar esta acción la solicitud de admisión finalizará y el

                usuario solicitante tanto como tú no podrán realizar ninguna

                otra acción con ella, además de que se da por entendido que los

                datos y documentos de la solicitud, son correctos.

              </div>

            </mdb-row>

            <mdb-row style="margin-top: 5rem">

              <div class="divLine"></div>

            </mdb-row>

            <mdb-row class="mt-3">

              <div style="margin-left: 20%">

                <Btn @onClick="finishedApp" :text="'SÍ, DESEO FINALIZAR LA SOLICITUD'" :type="'primary-admin'"

                  style="float: right"></Btn>

                <Btn @onClick="$refs.toFinish.toggleModal()" :text="'CANCELAR'" :type="'primary-admin-ghost'"

                  style="float: right; margin-right: 1rem"></Btn>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>

    <Loader v-show="isLoading" />

  </div>

</template>



<script>

import { mdbContainer, mdbRow, mdbCol, mdbPopover } from "mdbvue";

import { mapActions, mapGetters } from "vuex";

import Input from "../../core/Input";

import Btn from "../../core/Button";

import Accordion from "../../core/Accordion";

import AccordionAdmin from "../../core/AccordionAdmin";

import AccordionHeader from "../../core/Accordion/Header";

import Popup from "../../core/Popup";

import Swal from "sweetalert2";

import FileSaver from "file-saver";

import zoombox from "vue-zoombox";

import Loader from "../../core/Loader";

import 'quill/dist/quill.core.css';

import 'quill/dist/quill.snow.css';

import { quillEditor } from 'vue-quill-editor';



export default {

  name: "application",

  props: ["uuid", "object", "eventHub"],

  components: {

    mdbContainer,

    mdbRow,

    mdbCol,

    mdbPopover,

    Btn,

    Input,

    Accordion,

    AccordionHeader,

    ///////

    AccordionAdmin,

    Popup,

    zoombox,

    Loader,

    quillEditor,

  },

  data() {

    return {

      labelDomicilio: "Direccion de la propiedad",

      labelTerreno: "No. de terreno",

      labelAccion: "No. de acción",

      labelPropietario: "Nombre del propietario anterior",

      isLoading: false,

      commentToCommite: "",

      editorOptions: {

        theme: 'snow',

        modules: {

          toolbar: [

            ['bold', 'italic', 'underline'],

            [{ size: ['small', false, 'large', 'huge'] }],

            [{ list: 'ordered' }, { list: 'bullet' }],

            ['clean']

          ]

        }

      },

      indexPop: 1,

      indexSpouseTab: 1,

      indexChildTab: 1,

      popUrl: "",

      marital: "CASADO",

      secciones: [

        {

          titularSol: { check: false, save: false },

          titularPerso: { check: false, save: false },

          titularDom: { check: false, save: false },

          titularLab: { check: false, save: false },

          titularFact: { check: false, save: false },

          titularRecomendations: {

            socio0: { check: false, save: false },

            socio1: { check: false, save: false },

            socio2: { check: false, save: false },

            socio3: { check: false, save: false },

          },

          titularCars: {

            car0: { check: false, save: false },

            car1: { check: false, save: false },

            car2: { check: false, save: false },

            car3: { check: false, save: false },

            car4: { check: false, save: false },

            car5: { check: false, save: false },

          },

        },

      ],

      comentarios: [

        {

          titularSol: "",

          titularPerso: "",

          titularDom: "",

          titularLab: "",

          titularFact: "",

          titularRecomendations: {

            socio0: "",

            socio1: "",

            socio2: "",

            socio3: "",

          },

          titularCars: {

            car0: "",

            car1: "",

            car2: "",

            car3: "",

            car4: "",

            car5: "",

          },

        },

      ],

      LIST_DOCUMENTS_TRANSLATE: {

        CURP: "CURP",

        INE: "Identificación",

        PASSPORT: "Pasaporte",

        PROFILE_PICTURE: "Foto",

        BIRTH_CERTIFICATE: "Acta de nacimiento",

        TAX_STATUS_LETTER: "Constancia de situación fiscal",

        DEED_OR_AGREEMENT: "Escrituras/Convenio de adhesión",

        PROPERTY_PAYMENT: "Pago de predial",

        PROOF_OF_ADDRESS: "Comprobante de domicilio",

        CAR_BILL: "Factura(s) de de auto(s)",

        LOGO: "Logotipo",

      },

      selectedDocuments: {

        titular: {},

        spouse: {},

        minor_child: {},

        older_child: {},

      },

      //edad: "10",

      celPhone: "",

      homePhone: "",

      officePhone: "",

      //recomendations: [],

      indexRecomendation: 1,

      textComment: "",

      showTextArea: false,

      //check: [],

      titleModal: "",

      carBill: null,

      itsOk: false,

      billAddress: {

        state: "",

        city: "",

        colony: "",

        zipCode: "",

      },

      fileExtra: null,

      fileExtraBase64: null,

      fileConExtra: null,

      fileConExtraBase64: null,

      updateApplication: {

        id: null,

        application: {

          id: null,

          applicationStatus: null,

        },

        laborData: {

          comment: null,

        },

        billingInformation: {

          comment: null,

        },

        documents: [],

        cars: [],

        beneficiaries: [],

        recommendations: [],

      },

    };

  },

  methods: {

    ...mapActions([

      "checkRecommend",

      "getLocationSpecific",

      "downloadDocuments",

      "sendInvestigationExtra",

      "sendConInvestigationExtra",

      "sendApplicationToUpdate",

      "setAppInComite",

      "finishApp",

      "saveCommentsToComite",

    ]),

    findDocumentwithComment(array, documentType) {

      return array.find((item) => item.documentType == documentType);

    },

    toMoney(text) {

      var formatter = new Intl.NumberFormat("en-US", {

        style: "currency",

        currency: "USD",

      });



      return formatter.format(text);

    },

    async finishedApp() {

      this.$refs.toFinish.toggleModal();



      try {

        let response = await this.finishApp(this.app.application.id);

        if (response.data.status == 200) {

          Swal.fire({

            title:

              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>Solicitud Finalizada</span>",

            html:

              "<div>" +

              "<p>Se ha enviado un correo de aviso al solicitante.</p>" +

              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            onClose: () => {

              window.location.reload();

            },

          });

        }

      } catch (error) {

        //console.log(error.response);

        this.pushNotifyError(

          "Ha ocurrido un error al enviar el aviso al solicitante."

        );

      }

    },

    async checkSpouseData(data) {

      let spouse = data.beneficiaries.filter(function (item) {

        return item.beneficiaryType == "SPOUSE";

      });



      let investigation1 = spouse[0].documents.filter(function (item) {

        return item.documentType == "EXTRA_INVESTIGATION";

      });



      if (investigation1.length > 0 || this.fileConExtra != null) {

        return true;

      } else {

        return false;

      }

    },

    async checkBefore() {

      // let response = await this.getSingleApplication(this.checkedApp[0].id);

      // let isComplete = this.app.recommendations.filter(function (

      //   recomendation

      // ) {

      //   return recomendation.comments == null;

      // });



      let isComplete2 = this.recomendations.filter(function (item) {

        return item == null || item == "";

      });



      let extraInv = this.app.documents.filter(function (item) {

        return item.documentType == "EXTRA_INVESTIGATION";

      });



      let spouseComplete = true;



      if (

        this.app.maritalStatus == "MARRIED" &&

        this.app.application.membership.membershipName == "Familiar"

      ) {

        spouseComplete = await this.checkSpouseData(this.app);

      }



      let textoAuxiliar = null;



      if (isComplete2.length > 0) {

        textoAuxiliar = "Falta comentar por lo menos una recomendación";

      }



      if (extraInv.length == 0 && this.fileExtra == null) {

        textoAuxiliar = "Falta subir la investigación extra del titular";

      }



      if (!spouseComplete) {

        textoAuxiliar = "Falta subir la investigación extra del conyuge";

      }



      if (this.commentToCommite == "") {

        textoAuxiliar = "Falta agregar comentario para el comité";

      }



      if (textoAuxiliar == null) {

        this.$refs.toCom.toggleModal();

        this.sendToComite();

      } else {

        this.$refs.toCom.toggleModal();

        Swal.fire({

          title:

            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

          html:

            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

            "<p>La solicitud aún no está completada: <strong>" +

            textoAuxiliar +

            "</strong>.</p>" +

            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

            "</div>",

          allowOutsideClick: false,

          width: "50rem",

          padding: "2rem",

          confirmButtonText: "OK",

          confirmButtonColor: "#dc7134",

          customClass: {

            confirmButton: "t1-btn t1-btn--primary-block",

          },

        });

      }

    },

    async sendToComite() {

      let data = {

        id: this.app.application.id,

      };

      try {

        await this.setAppInComite(data);

        Swal.fire({

          title:

            " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>LA SOLICITUD SE HA ENVIADO A COMITÉ</span>",

          html:

            "<div>" +

            "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

            "</div>",

          allowOutsideClick: false,

          width: "50rem",

          padding: "2rem",

          confirmButtonText: "Ok",

          confirmButtonColor: "#dc7134",

          customClass: {

            confirmButton: "t1-btn t1-btn--primary-block",

          },

          onClose: () => {

            window.location.reload();

          },

        });

      } catch (error) {

        Swal.fire({

          title:

            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

          html:

            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

            "<p>La solicitud aún no está completada: <strong>" +

            error.response.data.errorDetails +

            "</strong>.</p>" +

            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

            "</div>",

          allowOutsideClick: false,

          width: "50rem",

          padding: "2rem",

          confirmButtonText: "OK",

          confirmButtonColor: "#dc7134",

          customClass: {

            confirmButton: "t1-btn t1-btn--primary-block",

          },

          onClose: () => { },

        });

      }

    },

    async saveComments() {

      let data = {

        id: this.app.application.id,

        body: {

          comment: this.commentToCommite,

        },

      };

      let response = await this.saveCommentsToComite(data);

      if (response.data.status == 200) {

        this.registerDone("LOS COMENTARIOS SE GUARDARON CORRECTAMENTE");

      } else {

        alert("HA OCURRIDO UN ERROR");

      }

    },

    registerDone(text) {

      Swal.fire({

        title:

          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>" +

          text +

          "</span>",

        html:

          "<div>" +

          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

          "</div>",

        allowOutsideClick: false,

        width: "50rem",

        padding: "2rem",

        confirmButtonText: "Ok",

        confirmButtonColor: "#dc7134",

        customClass: {

          confirmButton: "t1-btn t1-btn--primary-block",

        },

        onClose: () => {

          //window.location.reload();

        },

      });

    },

    async toUpdateApplication() {

      // //console.log(this.updateApplication);

      this.$refs.toUpdate.toggleModal();

      const jsonCorrections = {

        laborData: this.updateApplication.laborData,

        billingInformation: this.updateApplication.billingInformation,

        documents: this.updateApplication.documents,

        cars: this.updateApplication.cars,

        beneficiaries: this.updateApplication.beneficiaries,

        recommendations: this.updateApplication.recommendations,

      };



      this.updateApplication.jsonCorrections = JSON.stringify(jsonCorrections);



      try {

        this.isLoading = true;

        let response = await this.sendApplicationToUpdate(

          this.updateApplication

        );

        this.isLoading = false;

        if (response.data.status == 200) {

          Swal.fire({

            title:

              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>Información enviada al solicitante </span>",

            html:

              "<div>" +

              "<p class='mt-2'  style=' font-size: 14px; color: #828282; font-weight: normal'></p>" +

              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            onClose: () => {

              this.updateApplication = null;

              window.location.reload();

            },

          });

        }

      } catch (error) {

        this.isLoading = false;

        //console.log(error.response);

        this.pushNotifyError(

          "Ha ocurrido un error al enviar el aviso al solicitante."

        );

      }

    },

    saveDataUpdate(section, userType, object) {

      if (this.updateApplication.id == null) {

        this.updateApplication.id = this.app.id;

        this.updateApplication.application.id = this.app.application.id;

        this.updateApplication.application.applicationStatus =

          this.app.application.applicationStatus;

      }

      if (userType == "Titular") {

        if (section == "Solicitud") {

          let aux = this.app.documents.filter(function (item) {

            return item.documentType == "PROFILE_PICTURE";

          });



          let doc = {

            id: aux[0].id,

            documentType: "PROFILE_PICTURE",

            comment: this.comentarios[0].titularSol,

          };

          this.updateApplication.documents.push(doc);



          if (

            this.app.application.subProceedingType &&

            this.app.application.subProceedingType.subProceedingTypeValue ==

            "Traspaso"

          ) {

            aux = this.app.documents.filter(function (item) {

              return item.documentType == "DEED_OR_AGREEMENT";

            });



            doc = {

              id: aux[0].id,

              documentType: "DEED_OR_AGREEMENT",

              comment: this.comentarios[0].titularSol,

            };

            this.updateApplication.documents.push(doc);



            let aux = this.app.documents.filter(function (item) {

              return item.documentType == "PROPERTY_PAYMENT";

            });



            doc = {

              id: aux[0].id,

              documentType: "PROPERTY_PAYMENT",

              comment: this.comentarios[0].titularSol,

            };

            this.updateApplication.documents.push(doc);

          }

          this.secciones[0].titularSol.save = true;

        }

        if (section == "Personales") {

          let aux = this.app.documents.filter(function (item) {

            return item.documentType == "INE";

          });

          let doc = {

            id: aux[0].id,

            documentType: "INE",

            comment: this.comentarios[0].titularPerso,

          };

          this.updateApplication.documents.push(doc);



          aux = this.app.documents.filter(function (item) {

            return item.documentType == "CURP";

          });

          doc = {

            id: aux[0].id,

            documentType: "CURP",

            comment: this.comentarios[0].titularPerso,

          };

          this.updateApplication.documents.push(doc);



          aux = this.app.documents.filter(function (item) {

            return item.documentType == "BIRTH_CERTIFICATE";

          });

          doc = {

            id: aux[0].id,

            documentType: "BIRTH_CERTIFICATE",

            comment: this.comentarios[0].titularPerso,

          };

          this.updateApplication.documents.push(doc);

          this.secciones[0].titularPerso.save = true;

        }

        if (section == "Laborales") {

          // let aux = this.app.documents.filter(function (item) {

          //   return item.documentType == "TAX_STATUS_LETTER";

          // });

          //   if(aux.length > 0){

          // let doc = {

          //   id: aux[0].id,

          //   documentType: "TAX_STATUS_LETTER",

          //   comment: this.comentarios[0].titularLab,

          // };

          // this.updateApplication.documents.push(doc);

          // }

          this.updateApplication.laborData.comment =

            this.comentarios[0].titularLab;

          this.secciones[0].titularLab.save = true;

        }

        if (section == "Autos") {

          this.updateApplication.cars.push({

            id: object.id,

            comment: object.comment,

          });

          this.secciones[0].titularCars["car" + object.index].save = true;

        }

        if (section == "Recomendaciones") {

          this.updateApplication.recommendations.push({

            id: object.id,

            commentApplicant: object.comment,

          });

          this.secciones[0].titularRecomendations[

            "socio" + object.index

          ].save = true;

        }

        if (section == "Facturacion") {

          this.updateApplication.billingInformation.comment =

            this.comentarios[0].titularFact;

          this.secciones[0].titularFact.save = true;

        }

        if (section == "Domicilio") {

          let aux = this.app.documents.filter(function (item) {

            return item.documentType == "PROOF_OF_ADDRESS";

          });



          let doc = {

            id: aux[0].id,

            documentType: "PROOF_OF_ADDRESS",

            comment: this.comentarios[0].titularDom,

          };

          this.updateApplication.documents.push(doc);

          this.secciones[0].titularDom.save = true;

        }

      } else if (userType == "Conyuge") {

        let indexBenef = null;

        if (this.updateApplication.beneficiaries.length == 0) {

          this.updateApplication.beneficiaries.push({

            id: this.spouseData[0].id,

            beneficiaryType: "SPOUSE",

            name: this.spouseData[0].name,

            lastName: this.spouseData[0].lastName,

            mothersLastName: this.spouseData[0].mothersLastName,

            laborData: {

              comment: null,

            },

            documents: [],

          });

          indexBenef = 0;

        } else {

          for (let index in this.updateApplication.beneficiaries) {

            if (

              this.updateApplication.beneficiaries[index].id ==

              this.spouseData[0].id

            ) {

              indexBenef = index;

            }

          }

          if (indexBenef == null) {

            this.updateApplication.beneficiaries.push({

              id: this.spouseData[0].id,

              beneficiaryType: "SPOUSE",

              name: this.spouseData[0].name,

              lastName: this.spouseData[0].lastName,

              mothersLastName: this.spouseData[0].mothersLastName,

              laborData: {

                comment: null,

              },

              documents: [],

            });

            indexBenef = this.updateApplication.beneficiaries.length - 1;

          }

        }



        if (section == "Personales") {

          let aux = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "PROFILE_PICTURE";

          });



          let doc = {

            id: aux[0].id,

            documentType: "PROFILE_PICTURE",

            comment: this.comentarios[1].conyugeSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);



          aux = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "INE";

          });

          doc = {

            id: aux[0].id,

            documentType: "INE",

            comment: this.comentarios[1].conyugeSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);



          aux = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "CURP";

          });

          doc = {

            id: aux[0].id,

            documentType: "CURP",

            comment: this.comentarios[1].conyugeSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);



          aux = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "BIRTH_CERTIFICATE";

          });

          doc = {

            id: aux[0].id,

            documentType: "BIRTH_CERTIFICATE",

            comment: this.comentarios[1].conyugeSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          this.secciones[1].conyugeSol.save = true;

        }



        if (section == "Laborales") {

          // let aux = this.spouseData[0].documents.filter(function (item) {

          //   return item.documentType == "TAX_STATUS_LETTER";

          // });

          // if(aux.length > 0){

          // let doc = {

          //   id: aux[0].id,

          //   documentType: "TAX_STATUS_LETTER",

          //   comment: this.comentarios[1].conyugeLab,

          // };

          // this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          // }

          this.updateApplication.beneficiaries[indexBenef].laborData.comment =

            this.comentarios[1].conyugeLab;

          this.secciones[1].conyugeLab.save = true;

        }



        if (section == "Domicilio") {

          let aux = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "PROOF_OF_ADDRESS";

          });

          let doc = {

            id: aux[0].id,

            documentType: "PROOF_OF_ADDRESS",

            comment: this.comentarios[1].ConyugeDom,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          this.secciones[1].ConyugeDom.save = true;

        }

      } else {

        let indexBenef = null;

        if (this.updateApplication.beneficiaries.length == 0) {

          indexBenef = 0;

          if (object.benef.beneficiaryType == "OLDER_CHILD") {

            this.updateApplication.beneficiaries.push({

              id: object.benef.id,

              beneficiaryType: "OLDER_CHILD",

              name: object.benef.name,

              lastName: object.benef.lastName,

              mothersLastName: object.benef.mothersLastName,

              laborData: {

                comment: null,

              },

              documents: [],

            });

          } else {

            this.updateApplication.beneficiaries.push({

              id: object.benef.id,

              beneficiaryType: "MINOR_CHILD",

              name: object.benef.name,

              lastName: object.benef.lastName,

              mothersLastName: object.benef.mothersLastName,

              documents: [],

            });

          }

        } else {

          for (let index in this.updateApplication.beneficiaries) {

            if (

              this.updateApplication.beneficiaries[index].id == object.benef.id

            ) {

              indexBenef = index;

            }

          }

          if (indexBenef == null) {

            if (object.benef.beneficiaryType == "OLDER_CHILD") {

              this.updateApplication.beneficiaries.push({

                id: object.benef.id,

                beneficiaryType: "OLDER_CHILD",

                name: object.benef.name,

                lastName: object.benef.lastName,

                mothersLastName: object.benef.mothersLastName,

                laborData: {

                  comment: null,

                },

                documents: [],

              });

            } else {

              this.updateApplication.beneficiaries.push({

                id: object.benef.id,

                beneficiaryType: "MINOR_CHILD",

                name: object.benef.name,

                lastName: object.benef.lastName,

                mothersLastName: object.benef.mothersLastName,

                documents: [],

              });

            }

            indexBenef = this.updateApplication.beneficiaries.length - 1;

          }

        }

        //////////////////////////////////////////

        if (section == "Personales") {

          let aux = object.benef.documents.filter(function (item) {

            return item.documentType == "PROFILE_PICTURE";

          });



          let doc = {

            id: aux[0].id,

            documentType: "PROFILE_PICTURE",

            comment: this.comentarios[object.index + 2].benefSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);



          if (object.benef.beneficiaryType == "OLDER_CHILD") {

            aux = object.benef.documents.filter(function (item) {

              return item.documentType == "INE";

            });



            doc = {

              id: aux[0].id,

              documentType: "INE",

              comment: this.comentarios[object.index + 2].benefSol,

            };

            this.updateApplication.beneficiaries[indexBenef].documents.push(

              doc

            );

          }



          aux = object.benef.documents.filter(function (item) {

            return item.documentType == "CURP";

          });



          doc = {

            id: aux[0].id,

            documentType: "CURP",

            comment: this.comentarios[object.index + 2].benefSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);



          aux = object.benef.documents.filter(function (item) {

            return item.documentType == "BIRTH_CERTIFICATE";

          });



          doc = {

            id: aux[0].id,

            documentType: "BIRTH_CERTIFICATE",

            comment: this.comentarios[object.index + 2].benefSol,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          this.secciones[object.index + 2].benefSol.save = true;

        }



        if (section == "Laborales") {

          // let aux = object.benef.documents.filter(function (item) {

          //   return item.documentType == "TAX_STATUS_LETTER";

          // });

          // let doc = {

          //   id: aux[0].id,

          //   documentType: "TAX_STATUS_LETTER",

          //   comment: this.comentarios[object.index + 2].benefLab,

          // };

          // this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          this.updateApplication.beneficiaries[indexBenef].laborData.comment =

            this.comentarios[object.index + 2].benefLab;

          this.secciones[object.index + 2].benefLab.save = true;

        }



        if (section == "Domicilio") {

          let aux = object.benef.documents.filter(function (item) {

            return item.documentType == "PROOF_OF_ADDRESS";

          });

          let doc = {

            id: aux[0].id,

            documentType: "PROOF_OF_ADDRESS",

            comment: this.comentarios[object.index + 2].ConyugeDom,

          };

          this.updateApplication.beneficiaries[indexBenef].documents.push(doc);

          this.secciones[object.index + 2].benefDom.save = true;

        }

        //BENEFICIARIOS

      }

      this.$notify.success({

        message: "Comentario guardado correctamente",

        position: "bottom right",

        timeOut: 5000,

      });

    },

    pushNotifyError(message = "Ha ocurrido un error, inténtalo más tarde.") {

      this.$notify.error({

        message,

        position: "top right",

        timeOut: 15000,

      });

    },

    async getBillAddress() {

      try {

        let response = await this.getLocationSpecific(

          this.app.billingInformation.address.location.id

        );



        this.billAddress = response.data.data;

      } catch (error) { }

    },

    filterDocumentsForCheck(array, key) {

      return Object.values(

        array.reduce((acc, cur) => Object.assign(acc, { [cur[key]]: cur }), {})

      ).sort((a, b) =>

        this.LIST_DOCUMENTS_TRANSLATE[a[key]] <

          this.LIST_DOCUMENTS_TRANSLATE[b[key]]

          ? -1

          : this.LIST_DOCUMENTS_TRANSLATE[a[key]] >

            this.LIST_DOCUMENTS_TRANSLATE[b[key]]

            ? 1

            : 0

      );

    },

    getTypesFromDocuments(documents) {

      return documents.map(({ documentType }) => documentType);

    },

    async downloadFiles(

      { beneficiaryId = null, applicantId = null, type = null },

      downloadAll = false

    ) {

      try {

        let documentsToDownload = [];

        if (!downloadAll) {

          const obj = this.selectedDocuments[type];

          const keys = Object.keys(obj);



          documentsToDownload = keys.filter(function (key) {

            return obj[key];

          });

        } else if (Array.isArray(downloadAll) && downloadAll.length > 1) {

          documentsToDownload = downloadAll;

        }



        if (documentsToDownload.length === 0) {

          this.pushNotifyError(

            "No ha seleccionado ningún archivo para descargar."

          );

          return;

        }



        const body = {

          downloadDocuments: documentsToDownload.join(","),

        };



        if (beneficiaryId) {

          Object.assign(body, { beneficiaryId });

        } else if (applicantId) {

          Object.assign(body, { applicantId });

        } else {

          this.pushNotifyError(

            "No se encontró un usuario para descargar los documentos."

          );

          return;

        }

        Swal.fire({

          title: "Descargando...",

          allowOutsideClick: false,

          allowEscapeKey: false,

          onBeforeOpen: () => {

            Swal.showLoading();

          },

        });

        const response = await this.downloadDocuments(body);

        FileSaver.saveAs(new Blob([response.data]), "documents.zip");

      } catch (e) {

        this.pushNotifyError(

          "Ha ocurrido un error al descargar los documentos."

        );

      } finally {

        Swal.close();

      }

    },

    getCelPhone() {

      let phone = this.app.phones.filter(function (item) {

        return item.phoneType == "Celular";

      });



      if (phone.length > 0) {

        this.celPhone = phone[0].phoneNumber;

      }



      phone = this.app.phones.filter(function (item) {

        return item.phoneType == "Casa";

      });



      if (phone.length > 0) {

        this.homePhone = phone[0].phoneNumber;

      }



      phone = this.app.phones.filter(function (item) {

        return item.phoneType == "Oficina";

      });



      if (phone.length > 0) {

        this.officePhone = phone[0].phoneNumber;

      }

    },

    // addRecomendation() {

    //   this.recomendations[this.indexRecomendation - 1] = this.textComment;

    //   this.textComment = "";

    //   this.showTextArea = false;

    //   let isComplete = this.recomendations.filter(function (item) {

    //     return item == null || item == "";

    //   });

    //   if (isComplete.length > 0) this.itsOk = false;

    //   else this.itsOk = true;

    // },

    async saveRecomendations() {

      this.recomendations[this.indexRecomendation - 1] = this.textComment;

      this.textComment = "";

      this.showTextArea = false;

      let DTO = [];



      let objt = {

        id: this.app.recommendations[this.indexRecomendation - 1].id,

        hasBeenRecommended: this.check[this.indexRecomendation - 1],

        comments: this.recomendations[this.indexRecomendation - 1],

      };

      DTO.push(objt);



      let data = {

        id: this.app.application.id,

        body: {

          recommendationsDTO: DTO,

        },

      };



      let response = await this.checkRecommend(data);

      if (response.data.status == 200) {

        this.registerDone("REGISTRO CORRECTO");

      } else {

        alert("HA OCURRIDO UN ERROR");

      }

    },

    checkRecomendation(index) {

      this.showTextArea = true;

      this.indexRecomendation = index + 1;

      if (this.recomendations[this.indexRecomendation - 1]) {

        this.textComment = this.recomendations[this.indexRecomendation - 1];

      } else {

        this.textComment = "";

      }

    },

    openModal(url, title) {

      this.popUrl = url;

      this.titleModal = title;

      this.$refs.confirm.toggleModal();

    },



    openModal2(url, title) {

      this.popUrl = url;

      this.titleModal = title;

      this.$refs.profile.toggleModal();

    },

    getEdad() {

      var aux = this.app.birthDate.split("-");

      var año = aux[2];

      var mes = aux[1];

      var dia = aux[0];

      var date1 = new Date(año + "-" + mes + "-" + dia);



      var diff_ms = Date.now() - date1.getTime();

      var age_dt = new Date(diff_ms);

      var age_dt = new Date(diff_ms);

      var age_dt = new Date(diff_ms);



      this.edad = Math.abs(age_dt.getUTCFullYear() - 1970);

    },

    getMaritalName() { },

    getFactura(placa, modalName) {

      let documentPlate = this.app.documents.filter(function (item) {

        return item.value == placa;

      });



      if (documentPlate.length > 0) {

        this.carBill = documentPlate[0];

        this.openModal(this.carBill.publicURL, modalName);

      }

    },

    uploadExtra: function (evt) {

      this.fileExtra = URL.createObjectURL(evt.target.files[0]);

      //this.extension = evt.target.files[0].type;

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.fileExtraBase64 = e.target.result.split(",")[1];

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    uploadConExtra: function (evt) {

      this.fileConExtra = URL.createObjectURL(evt.target.files[0]);

      //this.extension = evt.target.files[0].type;

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.fileConExtraBase64 = e.target.result.split(",")[1];

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    async saveExtraInvestigation() {

      try {

        let data = {

          id: this.app.id,

          body: {

            extraInvestigation: {

              documentType: "EXTRA_INVESTIGATION",

              value: "",

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.fileExtraBase64,

            },

          },

        };

        let response = await this.sendInvestigationExtra(data);

        if (response.data.status == 200) {

          Swal.fire({

            title:

              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>Investigación guardada correctamente </span>",

            html:

              "<div>" +

              "<p class='mt-2'  style=' font-size: 14px; color: #828282; font-weight: normal'></p>" +

              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            onClose: () => {

              this.fileExtraBase64 = null;

              this.fileConExtraBase64 = null;

            },

          });

        }

      } catch (error) {

        //console.log(error.response.data.errorDetails);

        this.pushNotifyError(

          "Ha ocurrido un error al enviar la investigación."

        );

      }

    },

    async saveConExtraInvestigation() {

      try {

        let data = {

          id: this.spouseData[0].id,

          body: {

            extraInvestigation: {

              documentType: "EXTRA_INVESTIGATION",

              value: "",

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.fileConExtraBase64,

            },

          },

        };

        let response = await this.sendConInvestigationExtra(data);

        if (response.data.status == 200) {

          Swal.fire({

            title:

              " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>Investigación guardada correctamente </span>",

            html:

              "<div>" +

              "<p class='mt-2'  style=' font-size: 14px; color: #828282; font-weight: normal'></p>" +

              "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            onClose: () => {

              this.fileConExtraBase64 = null;

              this.fileExtraBase64 = null;

            },

          });

        }

      } catch (error) {

        //console.log(error.response.data.errorDetails);

        this.pushNotifyError(

          "Ha ocurrido un error al enviar la investigación."

        );

      }

    },

    async beforeEnter() {

      if (this.app != null) {

        if (this.app.maritalStatus == "MARRIED") {

          this.marital = "CASADO";

        }

        if (this.app.maritalStatus == "SINGLE") {

          this.marital = "SOLTERO";

        }

        if (this.app.maritalStatus == "DIVORCED") {

          this.marital = "DIVORCIADO";

        }

        if (this.app.maritalStatus == "WIDOWED") {

          this.marital = "VIUDO";

        }



        if (this.app.application.subProceedingType) {

          if (

            this.app.application.subProceedingType.subProceedingTypeValue ==

            "Venta nueva"

          ) {

            this.labelDomicilio = "Domicilio de la casa a adquirir:";

            this.labelTerreno = "No. de terreno:";

          }



          if (

            this.app.application.subProceedingType.subProceedingTypeValue ==

            "Traspaso"

          ) {

            this.labelDomicilio = "Domicilio de la casa a adquirir:";

            this.labelTerreno = "No. de terreno:";

            this.labelPropietario = "Nombre del propietario anterior:";

          }

        }



        try {

          if (

            this.app.application.proceedingType.proceedingTypeValue ==

            "Rentar solo Casa"

          ) {

            this.labelPropietario = "Nombre del propietario:";

            this.labelDomicilio = "Domicilio de la casa a rentar:";

          }

          if (

            this.app.application.proceedingType.proceedingTypeValue ==

            "Rentar solo Acción"

          ) {

            this.labelPropietario = "Nombre del propietario de la acción:";

            this.labelAccion = "No. de acción:";

          }

          if (

            this.app.application.proceedingType.proceedingTypeValue ==

            "Renta Casa y Acción"

          ) {

            this.labelPropietario =

              "Nombre completo del propietario de la casa:";

            this.labelDomicilio = "Domicilio de la casa a rentar:";

            this.labelAccion = "No. de acción a rentar:";

          }

        } catch (error) {

          //console.log("NO HAY DATOS DE TIPO DE TRAMITE");

        }



        let investigation1 = this.app.documents.filter(function (item) {

          return item.documentType == "EXTRA_INVESTIGATION";

        });



        if (investigation1.length > 0) {

          this.fileExtra = investigation1[0].publicURL;

        }



        if (this.app.application.comments.length > 0)

          this.commentToCommite = this.app.application.comments[0].comment;



        ///COMENTARIOS////

        let coment = this.app.documents.filter(function (item) {

          return item.documentType == "PROFILE_PICTURE";

        });

        this.comentarios[0].titularSol =

          coment.length > 0 ? coment[0].comment : "";



        coment = this.app.documents.filter(function (item) {

          return item.documentType == "CURP";

        });

        this.comentarios[0].titularPerso =

          coment.length > 0 ? coment[0].comment : "";



        // coment = this.app.documents.filter(function (item) {

        //   return item.documentType == "TAX_STATUS_LETTER";

        // });



        // if (coment.length > 0)

        //   this.comentarios[0].titularLab = coment[0].comment;

        // else this.comentarios[0].titularLab = "";



        if (this.app.laborData.comment)

          this.comentarios[0].titularLab = this.app.laborData.comment;

        ////RECOMENDACIONES

        for (let index in this.app.recommendations) {

          this.secciones[0].titularRecomendations["socio" + index] = {

            check: false,

            save: false,

          };

          this.comentarios[0].titularRecomendations["socio" + index] =

            this.app.recommendations[index].commentApplicant;

        }



        if (

          this.app.application.applicationStatus == "IN_EDIT_ACCEPTED" ||

          this.app.application.applicationStatus == "DOCUMENTATION_FINISHED"

        ) {

          coment = this.app.documents.filter(function (item) {

            return item.documentType == "PROOF_OF_ADDRESS";

          });

          this.comentarios[0].titularDom =

            coment.length > 0 ? coment[0].comment : "";

          this.comentarios[0].titularFact = this.app.billingInformation.comment;

        }



        ///COMENTARIOS CONYUGE



        if (this.spouseData) {

          let seccionesSpouse = {

            conyugeSol: { check: false, save: false },

            conyugeLab: { check: false, save: false },

            ConyugeDom: { check: false, save: false },

          };

          this.secciones.push(seccionesSpouse);



          let conyugeSol = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "PROFILE_PICTURE";

          });

          // let conyugeLab = this.spouseData[0].documents.filter(function (item) {

          //   return item.documentType == "TAX_STATUS_LETTER";

          // });

          let conyugeDom = this.spouseData[0].documents.filter(function (item) {

            return item.documentType == "PROOF_OF_ADDRESS";

          });



          let comentariosSpouse = {

            conyugeSol:

              conyugeSol[0].comment == null ? "" : conyugeSol[0].comment,

            conyugeLab:

              this.spouseData[0].laborData.comment == null

                ? ""

                : this.spouseData[0].laborData.comment,

            ConyugeDom:

              conyugeDom.length > 0

                ? conyugeDom[0].comment == null

                  ? ""

                  : conyugeDom[0].comment

                : "",

          };

          this.comentarios.push(comentariosSpouse);

        } else {

          let seccionesSpouse = {};

          this.secciones.push(seccionesSpouse);



          let comentariosSpouse = {};

          this.comentarios.push(comentariosSpouse);

        }

        ///COMENTARIOS BENEFICARIOS

        if (this.beneficiaries) {

          for (let item in this.beneficiaries) {

            if (this.beneficiaries[item].beneficiaryType == "OLDER_CHILD") {

              var seccionBenef = {

                bSol: { check: false, save: false },

                benefLab: { check: false, save: false },

                benefDom: { check: false, save: false },

              };

              this.secciones.push(seccionBenef);



              var _benefSol = this.beneficiaries[item].documents.filter(

                function (doc) {

                  return doc.documentType == "PROFILE_PICTURE";

                }

              );

              // var _benefLab = this.beneficiaries[item].documents.filter(

              //   function (doc) {

              //     return doc.documentType == "TAX_STATUS_LETTER";

              //   }

              // );

              var _benefDom = this.beneficiaries[item].documents.filter(

                function (doc) {

                  return doc.documentType == "PROOF_OF_ADDRESS";

                }

              );

              var comentariosBenef = {

                benefSolCom: _benefSol[0].comment,

                benefLab: this.beneficiaries[item].laborData.comment

                  ? this.beneficiaries[item].laborData.comment

                  : "",

                benefDom: _benefDom[0].comment,

              };

              this.comentarios.push(comentariosBenef);

            } else {

              var _seccionBenef = {

                bSol: { check: false, save: false },

                benefDom: { check: false, save: false },

              };

              this.secciones.push(_seccionBenef);

              var benefSol = this.beneficiaries[item].documents.filter(

                (doc) => doc.documentType == "PROFILE_PICTURE"

              );



              var benefDom = this.beneficiaries[item].documents.filter(

                function (doc) {

                  return doc.documentType == "PROOF_OF_ADDRESS";

                }

              );

              var _comentariosBenef = {

                benefSolCom: benefSol[0].comment,

                benefDom: benefDom[0].comment,

              };

              this.comentarios.push(_comentariosBenef);

            }

          }

        }

        //AUTOS

        try {

          for (let index in this.app.cars) {

            this.secciones[0].titularCars["car" + index] = {

              check: false,

              save: false,

            };

            let car = this.app.documents.filter(function (item) {

              let aux = this;

              return (

                item.documentType == "CAR_BILL" &&

                item.value == aux.app.cars[index].plates

              );

            });

            this.comentarios[0].titularCars["car" + index] = car[0].comment;

          }

        } catch (error) {

          //console.log(error);

        }

      }

    },

    maxCharCount() {

      if (this.commentToCommite && this.commentToCommite.length == 3000) {

        Swal.fire({

          title:

            "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",

          html:

            "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

            "<p>No es posible añadir más texto, se ha superado el límite.</p>" +

            "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

            "</div>",

          allowOutsideClick: false,

          width: "50rem",

          padding: "2rem",

          confirmButtonText: "Ok",

          confirmButtonColor: "#dc7134",

          customClass: {

            confirmButton: "t1-btn t1-btn--primary-block",

          },

          onClose: () => { },

        });

      }

      return (

        3000 -

        (this.commentToCommite != null ? this.commentToCommite.length : 0) +

        " / " +

        3000 +

        " Caracteres"

      );

    },

  },

  async mounted() {

    await this.beforeEnter();

  },

  computed: {

    ...mapGetters({

      loginUserType: "getUserType",

      app: "getApp",

      check: "getChecks",

      recomendations: "getRecomendations",

      titularOpen: "getTitular",

      conyugeOpen: "getConyuge",

      beneficiariesOpen: "getBeneficiaries",

      addressT: "getAddressT",

      addressBenef: "getAddressBenef",

      addressSpouse: "getAddressSpouse",

      addressBill: "getAddressBill",

    }),

    checkToCorrect() {

      if (

        this.loginUserType == "PARTNER_SERVICE" &&

        (this.app.application.applicationStatus ==

          "IN_REVIEW_BY_PARTNER_SERVICE" ||

          this.app.application.applicationStatus ==

          "IN_EDIT_BY_PARTNER_SERVICE")

      )

        return true;

      else return false;

    },

    corrections() {

      let array = [];



      this.app.application.corrections.forEach((item) => {

        let correccion = {};

        correccion.editAt = item.editAt;

        correccion.editFrom = item.editFrom;

        correccion.corrections = JSON.parse(item.jsonCorrections);

        array.push(correccion);

      });

      array.sort(function (a, b) {

        if (a.editFrom < b.editFrom) {

          return -1;

        }

        if (a.editFrom > b.editFrom) {

          return 1;

        }

        return 0;

      });

      return array;

    },

    hasPermissionToDownloadDocuments() {

      return (

        (this.loginUserType === "SALES" ||

          this.loginUserType === "PARTNER_SERVICE") &&

        this.app.application.applicationStatus !== "CREATED"

      );

    },

    // checksR() {

    //   let isComplete = this.recomendations.filter(function (item) {

    //     return item == null || item == "";

    //   });

    //   if (isComplete.length > 0) return this.itsOk = false;

    //   else return this.itsOk = true;

    // },

    TaxStatusLetter() {

      return this.app.documents.find(

        (doc) => doc.documentType === "TAX_STATUS_LETTER"

      );

    },

    DeedOrAgreement() {

      return this.app.documents.find(

        (doc) => doc.documentType === "DEED_OR_AGREEMENT"

      );

    },

    PropertyPayment() {

      return this.app.documents.find(

        (doc) => doc.documentType === "PROPERTY_PAYMENT"

      );

    },

    beneficiaries() {

      if (this.app.beneficiaries.length > 1) {

        return this.app.beneficiaries.filter(function (item) {

          return item.beneficiaryType != "SPOUSE";

        });

      } else {

        return null;

      }

    },

    spouseData() {

      if (this.app.beneficiaries.length > 0) {

        let spouse = this.app.beneficiaries.filter(function (item) {

          return item.beneficiaryType == "SPOUSE";

        });

        if (spouse.length > 0) {

          let investigation1 = spouse[0].documents.filter(function (item) {

            return item.documentType == "EXTRA_INVESTIGATION";

          });



          if (investigation1.length > 0) {

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties

            this.fileConExtra = investigation1[0].publicURL;

          }

          return spouse;

        } else {

          return null;

        }

      } else {

        return null;

      }

    },

    edad() {

      var aux = this.app.birthDate.split("-");

      var año = aux[2];

      var mes = aux[1];

      var dia = aux[0];

      var date1 = new Date(año + "-" + mes + "-" + dia);



      var diff_ms = Date.now() - date1.getTime();

      var age_dt = new Date(diff_ms);



      return Math.abs(age_dt.getUTCFullYear() - 1970);

    },

    showComment() {

      if (

        this.loginUserType == "PARTNER_SERVICE" &&

        (this.app.application.applicationStatus ==

          "IN_EDIT_BY_PARTNER_SERVICE" ||

          this.app.application.applicationStatus == "IN_EDIT_ACCEPTED")

      ) {

        return true;

      } else {

        return false;

      }

    },

    // charCount() {

    //   if (this.commentToCommite && this.commentToCommite.length == 3000) {

    //     Swal.fire({

    //       title:

    //         "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem;  color: #dc7134'>¡ATENCIÓN!</span>",

    //       html:

    //         "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

    //         "<p>No es posible añadir más texto, se ha superado el límite.</p>" +

    //         "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

    //         "</div>",

    //       allowOutsideClick: false,

    //       width: "50rem",

    //       padding: "2rem",

    //       confirmButtonText: "Ok",

    //       confirmButtonColor: "#dc7134",

    //       customClass: {

    //         confirmButton: "t1-btn t1-btn--primary-block",

    //       },

    //       onClose: () => {},

    //     });

    //   }

    //   return (

    //     3000 -

    //     (this.commentToCommite != null ? this.commentToCommite.length : 0) +

    //     " / " +

    //     3000 +

    //     " Caracteres"

    //   );

    // },

    editableTextArea() {

      return !(

        (this.app.application.applicationStatus !=

          "IN_REVIEW_BY_PARTNER_SERVICE" &&

          this.app.application.applicationStatus !=

          "IN_EDIT_BY_PARTNER_SERVICE") ||

        this.loginUserType == "COMMITTEE"

      );

    },

    commentHTML() {

      if (!this.commentToCommite) return '';

      try {

        const doc = new DOMParser().parseFromString(this.commentToCommite, 'text/html');

        return doc.body.innerHTML;

      } catch (e) {

        return this.commentToCommite;

      }

    },

  },

  watch: {},

};

</script>



<style scoped>

.check-corrections {

  margin-right: 40px;

  font-size: 12px;

  font-weight: 600;

}



/* @media screen and (max-width: 1700px) {

  .check-corrections {

    float: right;

    font-size: 12px;

    font-weight: 600;

    position: absolute;

    left: -4rem;

  }

} */

</style>



<style>

/* Quill comment rendering */

.comment-html-viewer { line-height: 1.6; }

.comment-html-viewer p { margin-bottom: 0.4rem; }

.comment-html-viewer .ql-size-large { font-size: 1.2em; }

.comment-html-viewer .ql-size-huge { font-size: 1.5em; }

.comment-html-viewer .ql-size-small { font-size: 0.85em; }

.comment-html-viewer strong { font-weight: 700; }

.comment-html-viewer em { font-style: italic; }

.comment-html-viewer u { text-decoration: underline; }

.comment-html-viewer ol, .comment-html-viewer ul { padding-left: 1.5em; }

.comment-html-viewer li { margin-bottom: 0.2rem; }

/* Fix: Bootstrap overrides Quill inline formats inside the editor */
.ql-editor strong { font-weight: 700 !important; }
.ql-editor em { font-style: italic !important; }
.ql-editor u { text-decoration: underline !important; }



.accordion__content--active {

  padding: 0;

  height: auto;

  opacity: 1;

  visibility: visible;

  background-color: #f2f2f2;

}



.accordion {

  margin-left: 0 !important;

  margin-right: 0 !important;

  width: 100% !important;

}



.avatar-pic {

  /* position: absolute; */

  border: 0.6rem solid #285f46;

  border-radius: 50%;

  width: 10rem;

  height: 10rem;

}



.zoom-pic {

  position: absolute;

  border: 0.3rem solid #285f46;

  border-radius: 50%;

  width: 4rem;

  height: 4rem;

  top: 7rem;

  background: white url("/img/InoBuscar@3x.png") no-repeat center;

  background-size: 28px 28px;

  left: 7rem;

}



.table td,

.table th {

  font-size: 1.3rem;

}



.labelClass {

  font-size: 15px;

  font-weight: 600;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  color: #dc7134;

}



.divClass {

  width: 100%;

  padding: 3rem;

  background-color: #ffffff;

  text-align: start;



  font-size: 12px;

  font-weight: 300;

  color: #4f4f4f;

}



.documents-section {

  width: 100%;

  height: auto;

  display: block;

  margin: 0 auto;

}



.documents-section .accordion-header {

  background-color: #3a8a65;

  width: 100%;

  height: auto;

  color: #fff;

  text-align: left;

  font-weight: 600;

  font-size: 1.8rem;

  margin-left: auto;

  margin-right: auto;

  padding: 1.5rem 2rem;

  border-radius: 0.5rem;

}



.accordion-section {

  width: 95%;

  height: auto;

  margin: 0 auto;

  padding-bottom: 20px;

}



.accordion-section .content-info {

  width: 95%;

  height: auto;

  margin: 0 auto;

  padding: 50px 31px 0px 31px;

  background: #fff;

  padding-bottom: 20px;

}



.swal2-container {

  z-index: 10000000 !important;

}



.btn-label {

  border-radius: 5px;

  background-color: #dc7134;

  padding: 0.4rem 2.5rem;

  font-size: 12px;

  font-weight: normal;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  color: #ffffff;

  font-weight: 600;

  cursor: pointer;

}



.popover {

  width: 40rem !important;

  max-width: 500px !important;

}



textarea {

  resize: none;

}



.correct .accordion__content--active {

  padding: 0;

  height: auto;

  opacity: 1;

  visibility: visible;

  background-color: #f2f2f2;

}



.accordion {

  margin-left: 0 !important;

  margin-right: 0 !important;

  width: 100% !important;

}



.avatar-pic {

  /* position: absolute; */

  border: 0.6rem solid #285f46;

  border-radius: 50%;

  width: 10rem;

  height: 10rem;

}



.zoom-pic {

  position: absolute;

  border: 0.3rem solid #285f46;

  border-radius: 50%;

  width: 4rem;

  height: 4rem;

  top: 7rem;

  background: white url("/img/InoBuscar@3x.png") no-repeat center;

  background-size: 28px 28px;

  left: 7rem;

}



.table td,

.table th {

  font-size: 1.3rem;

}



.labelClass {

  font-size: 15px;

  font-weight: 600;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  color: #dc7134;

}



.divClass {

  width: 100%;

  padding: 3rem;

  background-color: #ffffff;

  text-align: start;



  font-size: 12px;

  font-weight: 300;

  color: #4f4f4f;

}



.documents-section {

  width: 100%;

  height: auto;

  display: block;

  margin: 0 auto;

}



.documents-section .accordion-header {

  background-color: #3a8a65;

  width: 100%;

  height: auto;

  color: #fff;

  text-align: left;

  font-weight: 600;

  font-size: 1.8rem;

  margin-left: auto;

  margin-right: auto;

  padding: 1.5rem 2rem;

  border-radius: 0.5rem;

}



.accordion-section {

  width: 95%;

  height: auto;

  margin: 0 auto;

  padding-bottom: 20px;

}



.accordion-section .content-info {

  width: 95%;

  height: auto;

  margin: 0 auto;

  padding: 50px 31px 0px 31px;

  background: #fff;

  padding-bottom: 20px;

}



.swal2-container {

  z-index: 10000000 !important;

}



.btn-label {

  border-radius: 5px;

  background-color: #dc7134;

  padding: 0.4rem 2.5rem;

  font-size: 12px;

  font-weight: normal;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  color: #ffffff;

  font-weight: 600;

  cursor: pointer;

}



.popover {

  width: 40rem !important;

  max-width: 500px !important;

}



textarea {

  resize: none;

}



.corrections-row {

  padding: 0 1rem;

  display: flex;

  justify-content: flex-end;

}



.check-corrections {

  margin-right: 40px;

  font-size: 12px;

  font-weight: 600;

}



/* @media screen and (max-width: 1700px) {

  .check-corrections {

    float: right;

    font-size: 12px;

    font-weight: 600;

    position: absolute;

    left: -4rem;

  }

} */

ions-row {

  padding: 0 1rem;

  display: flex;

  justify-content: flex-end;

}

@media screen and (min-width: 1440px) {

  .popover {

    transform: translate3d(331px, -137px, 0px) !important;

    

  }

  .popover textarea{

    max-height: 40vh !important;

  }

} 

</style>